Em.I18n.locales ||= {}
module.exports = Em.I18n.locales['es'] =
  status_mini_popup:
    confirm_sms_hint:
      'enviar una notificación por SMS al cliente sobre la confirmación del pedido'
    cancel_sms_hint:
      'enviar una notificación por SMS al cliente sobre la cancelación del pedido'
  draft_dish:
    weight_units:
      gram: 'gramos'
      kilogram: 'kilogramos'
      hundred_gram: '100 gramos'
      milliliter: 'mililitro'
      liter: 'litro'
      hundred_milliliter: '100 mililitros'
    weight_units_short:
      gram: 'g'
      hundred_gram: '100 g'
      milliliter: 'ml'
      kilogram: 'kg'
      liter: 'l'
      hundred_milliliter: '100 ml'
    excise_units:
      commodity: 'Producto'
      excise: 'Producto gravado'
      service: 'Servicio'
      excise_with_label: 'Producto gravado sin código de etiqueta'
      excise_without_label: 'Producto gravado con código de etiqueta'
      commodity_with_label: 'Producto no gravado con código de etiqueta'
      commodity_without_label: 'Producto no gravado sin código de etiqueta'
      other: 'Otro'
  loyalty:
    notifier:
      title: 'Programa de Fidelización {{text}}'
      status:
        new: 'creado'
        old: 'guardado'
    confirm:
      delete: '¿Eliminar programa de fidelización?'
      cancel: '¿Cancelar cambios?'
  client_tag_info:
    notifier:
      title: 'Etiqueta {{text}}'
      status:
        new: 'creado'
        old: 'guardado'
    confirm:
      delete: '¿Eliminar etiqueta?'
      cancel: '¿Cancelar cambios?'
  bonus_category_info:
    notifier:
      title: 'Categoría {{text}}'
      status:
        new: 'creada'
        old: 'guardada'
    confirm:
      delete: '¿Eliminar categoría de bonificación?'
      cancel: '¿Cancelar cambios?'
  banner:
    notifier:
      title: 'Banner {{text}}'
      status:
        new: 'creado'
        old: 'guardado'
    confirm:
      delete: '¿Borrar banner?'
      cancelar: '¿Deshacer cambios?'
      guardar: '¿Quieres guardar el banner antes de subir la imagen? ¿Guardar?'
  advert:
    notifier:
      title: 'Anuncio {{text}}'
      status:
        new: 'creado'
        old: 'guardado'
    filter:
      restaurants:
        zero_data:
          'El cliente debe tener al menos un pedido de los restaurantes seleccionados.'
        content: 'Restaurantes seleccionados: {{restaurants}}'
    confirm:
      delete: 'Borrar el anuncio?'
      cancel: 'Cancelar los cambios?'
      save: 'Debe guardar el anuncio antes de subir la foto. Guardar?'
      execute:
        'Confirme el inicio de la lista de correo. Se verá afectado {{clients}}'
      cancel: '¿Cancelar un anuncio previsto?'
    status:
      draft: 'borrador'
      scheduled: 'inició'
      processing: 'envío en curso'
      paused: 'envío está suspendido'
      canceled: 'envío está cancelado'
      complete: 'envío está completado'
    result:
      error:'Error'
      success: 'Exitosamente'
    transport:
      sms: 'SMS'
      email: 'E-mail'
      client_push_then_sms: 'Push, y después SMS'
      client_push: 'Push'
      communication_channels: 'Canales de сomunicación'
  sip:
    status:
      online: 'online'
      offline: 'offline'
      error: 'error'
      connecting: 'conexión'
      disconnecting: 'desconexión'
    error:
      init_failed: 'Formato de cuenta inválido SIP.'
      connection_failed: 'No se pudo conectar al SIP-proxy servidor.'
      registration_failed:
        'No registrado. Compruebe que los datos de entrada para la conexión son correctos.'
  c:
    client_tags:
      buttons:
        start_editing: 'editar etiquetas'
        finish_editing: 'terminar de editar'
        group_editing: 'Edición de Grupo'
        group_add: 'Agregar etiquetas a todos los clientes'
        group_delete: 'Eliminar etiquetas de todos los clientes'
        reset_filters: "Restablecer filtros"
        confirms:
          accept_reset_filters: 'Los filtros se restablecerán al estado original, ¿continuar?'
      notification:
        title: 'Hecho'
        message: 'Etiquetas de los clientes actualizadas'
    client_table:
      last_order_date: 'último pedido fue {{date}}'
      average_check: 'cheque promedio'
    account_photo: upload: 'Subir una foto'
    add_tag_button:
      add_button: 'Añadir'
      add_text: 'Añadir «{{q}}»'
      placeholder:
        search: 'Buscar una etiqueta'
    banner_photo:
      intro: 'Arrastre y suelte la foto o pulse subir'
      no_photo: 'Foto no subida'
      drop_photo: 'Suelta la foto para subirla'
      upload: 'Subir'
    advert_photo:
      intro: 'Arrastre la foto o haga clic en descargar'
      no_photo: 'Foto no está subida'
      drop_photo: 'Deje foto para subir'
      upload: 'Subir'
    billing_operation_table_row:
      invoice: 'se producirá el retiro de dinero al {{date}}'
      invoice_with_act: 'Servicios se han sido prestados {{date}}'
      invoice_date: 'Cuenta se ha sido generada {{date}}'
      download_act: 'Descargar la acta contable'
      download_invoice: 'Descargar la factura para pago'
      currency: 'rub.'
    carrier_item:
      available_in: 'Disponible en las ciudades:'
      rating:
        speed: 'la velocidad'
        price: 'el precio'
        quality: 'la calidad'
      connected: 'Conectado'
      carrier_sent: 'Solicitud<br>enviada'
      carrier_sent_hover: 'Enviar<br>solicitud de nuevo'
      connect: 'Conectar'
    client_card:
      no_name: 'Cliente sin nombre'
      address: 'Las direcciónes del cliente'
      blacklisted: 'El cliente está en la lista negra'
      client_comment: 'el comentario al cliente'
      bonuses:
        none: 'El cliente no tiene los bonos'
        one: 'El cliente tiene {{count}} punto de bonificación en la cuenta'
        few: 'El cliente tiene {{count}} puntos de bonificación en la cuenta'
        many: 'El cliente tiene {{count}} puntos de bonificación en la cuenta'
      save: 'Guardar'
      add_comment: 'añadir el comentario para el cliente'
    client_order_block:
      order_contents: 'El cotenido del pedido'
      item_amount: 'ps.'
      process: 'Procesado'
      unprocess: 'No procesado'
      process_error: 'No se puede cambiar el estado de procesamiento del pedido'
    clients_table_row:
      is_blacklisted: 'El cliente está en la lista negra'
      last_order_date: 'El último pedido fue el {{date}}'
  error_page:
    header: 'Error de carga de datos'
    comment:
      'Esto suele suceder cuando intenta abrir una orden o otra información donde los datos no están disponibles actualmente.'
    back_button: 'Regresa a la página principal'
  themes:
    title: 'Selección del tema'
    back_button: 'Atrás'
    publish_button: 'Publicar'
    change_theme: 'Cambiar el tema'
    common_settings: 'Configuración general'
    theme_settings: 'Opciones de tema'
    not_configurable: 'Este tema no tiene opciones configurables'
    reset_button: 'Restablecer configuración'

    notifications:
      publish:
        title: 'Publicado'
        message: '{{theme}} ha sido publicado en el sitio web del restaurante'
      reset:
        title: 'Éxito'
        message: 'Configuraciones de {{theme}} restablecidas con éxito'

    confirms:
      reset: 'Restablecer la configuración eliminará todas las preferencias del usuario. ¿Continuar?'

  client_edit:
    header:
      title: 'Cliente #'
      first_order: 'Pedido primero:'
      order_history: 'Historial de los pedidos'
      activity: 'Actividad del cliente'
      tabs:
        history: 'Historial de los pedido'
        bonuses: 'Los bonos'
        communications: 'Comunicaciones'

    form:
      card_track:
        label: 'Tarjeta de Bonos'
        placeholder: 'Número de la tarjeta de bonos'
      avatar: label: 'La foto'
      name:
        label: 'El nombre'
        placeholder: 'El nombre'
      phone:
        label: 'Teléfono'
        placeholder: 'Teléfono'
        call: 'llamar'
      email:
        label: 'E-mail'
        placeholder: 'E-mail'
      bonuses:
        label: 'Los bonos'
        placeholder: 'Ingrese la cantidad de los bonos'
        add: 'Añadir'
        substract: 'Retirar'
        confirm_transaction: '¿Cambiar de saldo?'
        amount:
          none: 'El cliente no tiene los bonos'
          one: 'El cliente tiene {{count}} punto de bonificación en la cuenta'
          few: 'El cliente tiene {{count}} puntos de bonificación en la cuenta'
          many: 'El cliente tiene {{count}} puntos de bonificación en la cuenta'
        count:
          none: ''
          one: 'un bono'
          few: 'bonos'
          many: 'bonos'
          other: 'bonos'
      issue: label: 'Expedir el código'
      birthday: label: 'El día de los cumpleaños'
      tags: label: 'Las etiquetas'
      recurrence: label: 'El regreso'
      comment:
        label: 'El comentario'
        placeholder: 'El comentario'
      black_list:
        label: 'La lista negra'
        control: 'Añadir a la lista negra'
        caption:
          'Los pedidos de este cliente serán marcados de una manera especial'
        comment: 'Motivo de la inclusión en la lista negra'
        listed_by: 'Quién y cuándo se envía a la lista negra'
    history:
      header: 'Historial de los pedidos'
      new_order: 'Un pedido nuevo'
      change_balance: 'Cambiar de saldo'
      cancel_balance_change: 'Cancelar'
      all: 'Todos'
      not_processed: 'No procesados'
      processed: 'Procesados'
      orders_to_show: 'Órdenes para mostrar'

    buttons:
      save: 'Guardar'
      delete: 'Eliminar'
      close: 'Cerrar'

  story_frame_edit:
    header:
      left: 'Imágenes del marco'
      right: 'Parámetros del marco'
    button_text: 'Texto del botón'
    button_url:  'URL del botón'
    photo_help: 'Arrastra una imagen o haz clic para subirla'
    no_photo: 'No se ha cargado imagen del marco'
    drop_photo: 'Suelta la imagen para subirla'
    save_banner_for_edit: 'Necesitas guardar el banner antes de hacer cambios. ¿Guardar?'

  dish_edit:
    photo:
      tabs:
        main: 'Foto Principal'
        additional: 'Fotos Adicionales'
    photo_help: 'Arrastre la foto o haga clic en subir'
    no_photo:
      'Foto del plato no está subido<br> Suba la foto para mostrarlo en el sitio'
    buttons:
      save: 'Guardar'
      delete: 'Eliminar'
      cancel: 'Cancelar'
    availability:
      title: 'Disponibilidad de los platos en el restaurante.'
      enabled_timetable: 'El plato tiene un horario de disponibilidad.'
      edit_timetable: 'Editar el horario'
      about_timetable:
        'El programa de disponibilidad permite automatizar la colocación y eliminación de las paradas de los platos..'
      about_availability:
        'Aquí puede esconder el plato del menú del restaurante, o tenga en cuenta que la presencia del plato requiere una aclaración por teléfono'
      no_available: 'Temporalmente no disponible'
      need_call: 'Especificar por teléfono'
      loading: 'Cargando'
    configurator:
      new_configurator_title: 'Nuevo configurador #{{ordinal}}'
      placeholders:
        item_name: 'el nombre'
        item_price: 'El precio'
      buttons:
        add_new_group:
          dish_group: 'Agregar Combo'
          modifier_group: 'Agregar Grupo de Modificadores'
        delete_configuration: 'Eliminar configuración'
        configuration_settings: 'Configurar configuración'
        add_new_configuration: 'Añadir configuración'
        remove_group: 'Eliminar grupo'
        remove_group_parent: 'Por defecto'
      config_types:
        label: 'Tipo de Configuración'
        modifier_group: 'Grupo de Modificadores'
        dish_group: 'Combo'
      type:
        modifier_group: 'Configuración del Grupo de Modificadores'
        dish_group: 'Configuración de Combo'
      parent: 'Depende del modificador'
      labels:
        base_price: 'Precio básico'
        allow_additional_comment: 'Permitir comentarios'
      configuration_settings: 'Personalizar una configuración'
      allow_additional_comment_caption: 'Permite a los clientes añadir comentarios al plato al hacer el pedido'
      add_new: 'Añadir una posición'
      base_price_caption:
        'Se utiliza para comenzar a calcular el precio total de un plato configurado'
      groups_zero_data: 'No se añadieron los grupos de configuración'
      multiple_select:
        title: 'Hay varias opciones para elegir'
        min: 'No menos de'
        max: 'y no mas de'
        about: 'opciones'
      zero_data:
        title: 'No se han creado configuraciones'
        caption:
          'Añada una configuración para darle al cliente la posibilidad de seleccionar opciones de platos. Un ejemplo de está configuración podría ser una selección de salsa, aderezo o tamaño de la porción.'
    header:
      edit: 'Edición del plato'
      readonly: 'Las opciónes del plato'
      tabs:
        configurator: 'Configurador'
        prices: 'Precios de restaurantes'
      configurator:
        edit: 'Configurador'
        readonly: 'Configurador (sólo vista)'
    form:
      slug:
        label: 'Slug'
        placeholder: 'Slug'
      ingridients: 'Ingredientes'
      calories: 'Calorías'
      proteins: 'Proteínas'
      fats: 'Grasas'
      carbs: 'Carbohidratos'
      title:
        app: 'Sitio web y aplicación'
        description: 'Descripción'
        integrations: 'Integraciones'
        promos: 'Promociones y bonificaciones'
        additional: 'Adicional'
      name:
        label: 'El nombre del plato'
        placeholder: 'El nombre del plato'
      price:
        label: 'El precio'
        placeholder: 'El precio'
      weight_price:
        label: 'Precio por {{unit}}'
        placeholder: 'Precio por {{unit}}'
      price_weight_unit:
        label: 'Unidades de medida para el cálculo de precios'
        placeholder: ''
      weight:
        label: 'El peso'
        placeholder: 'El peso'
      weight_unit:
        label: 'Unidades de medida'
        placeholder: ''
      excise_unit:
        label: 'Unidades de impuestos especiales'
        placeholder: ''
      external_id:
        label: 'Código externo (id)'
        placeholder: 'id'
        caption: 'Utilizado para integrar el widget Smartomato'
      description:
        label: 'Descripción'
        placeholder: 'Descripción'
      category: label: 'Categoría'
      suggesting:
        label:
          on: 'Prioridad de recomendación'
          off: '¿Recomendar este plato?'
        priority: 'Prioridad'
        disable: 'deshabilitar'
        caption:
          'Puede establecer un gran número de platos para ventas adicionales. , entonces las prioridades permitirán a Smartomato elegir el más adecuado para la recomendación.'
        enable: 'Incluye el plato en ventas adicionales'
      disabled_sources:
        label: 'Prohibición de descargar en agregadores'
        caption:
          'Puede prohibir la venta de un plato para un agregador particular o múltiples agregadores'
      extras:
        label: 'Además'
        is_list: 'Mostrar en el texto'
        can_zoom: 'Puede ampliar la imagen'
        is_hidden: 'Ocultar en el menú'
        is_stealthy: 'Ocultar del menú'
        is_bonus_only: 'El plato solo para los bonos'
        no_bonus_accrue: 'No hay bonos para este plato'
        dont_discount: 'No dar a este plato un descuento'
        prohibit_takeaway: 'Prohibir el plato en la recogida'
        prohibit_delivery: 'Prohibir el plato en la entrega'
        prohibit_dine_in: 'Prohibir cenar en el restaurante'
        is_popular: 'Mostrar en un bloque de platos populares'
        restrict_bonus_withdrawal: 'Prohibir la deducción de primas por este plato'
        is_required: 'Plato requerido'
      is_next_day:
        label: 'Entrega al día siguiente'
        toggle: 'Plato con la entrega al día siguienteь'
        hour_count:
          'Cantidad de las horas desde el comienzo del día siguiente'
        caption:
          'De forma predeterminada, los pedidos con tal plato se transferirán al comienzo del día siguiente y continuarán tomando tiempo desde las zonas de entrega.<br><br>Pero si la entrega se funciona después de la medianoche, estos platos se transferirán a las 00:0100:01.<br><br>El número de las horas permitirá mover el número especificado de las horas hacia adelante.<br><br>Puede establecer el tiempo global para toda la organización (para esto escríbanos en el chat) o individualmente para cada plato.'
      is_metric:
        label: 'Weight dish'
        toggle: 'Dish with weight'
      min_qty:
        weight: 'Peso mínimo ({{unit}})'
        volume: 'Volumen mínimo ({{unit}})'
      delta_qty:
        weight: 'Incremento de peso ({{unit}})'
        volume: 'Incremento de volumen ({{unit}})'
      old_price:
        label: 'Precio antiguo'
        placeholder: 'precio antiguo'
        caption: 'Este precio se mostrará en el sitio tachado'
      cooking:
        time:
          label: 'Tiempo de preparación'
          placeholder: 'Tiempo'
          caption:
            'Tiempo de preparación en minutos para calcular el horario de preparación..<br>Deje vacío si necesita usar el tiempo de preparación desde el área de entrega'
          unit: 'min'
        line:
          label: 'Taller'
          caption: 'Línea de producción donde se preparará el plato'
      tags:
        label: 'Etiquetas'
        placeholder: 'Vegetariano, Bajo en calorías, Picante'
        caption:
          'Puede indicar las palabras en la coma, cada tal palabra será la etiqueta en el sitio'
      meta_title:
        label: 'Meta title'
        placeholder: 'meta title'
      meta_description:
        label: 'Meta description'
        placeholder: 'meta description'
    prices:
      price:
        label: 'El precio'
        is_hidden: 'no hay en menú'
        is_default: 'ahora precios y disponibilidad por defecto'
        override: 'redefinir'
      base_price: label: 'Precio básico del configurador'
      disable: 'desactivar diferentes precios'
      zero_data:
        header: 'Precios y disponibilidad en restaurantes diferentes'
        caption:
          'Ahora el plato está incluido en el menú de todos los restaurantes al mismo precio'
        enable: 'Establecer diferentes precios o disponibilidad'
  category_edit:
    new: 'Nueva categoría'
    header:
      edit: 'Edición de lacategoría'
      readonly: 'Opciones de categoría'
    form:
      disclaimer: '＊ Soportado solo en la parte de los temas del diseño'
      name:
        label: 'Nombre de categoría'
        placeholder: 'Nombre de categoría'
      external_id:
        label: 'Código externo (id)'
        placeholder: 'id'
        caption:
          'Se utiliza al integrarse con sistemas de contabilidad de restaurantes'
      description:
        label: 'Descripción'
        placeholder: 'Descripción'
      parent: label: 'Categoría parental'
      export_hidden:
        label: 'Exportación oculta a agregadores'
      disabled_sources:
        label: 'Prohibir exportación a agregadores'
        caption: 'Puede prohibir la exportación de una categoría a un agregador específico o varios agregadores'
      extras:
        label: 'Además'
        is_list:
          'Mostrar contenido como texto (solo en parte de los temas del diseño)'
        is_hidden: 'Ocultar en el menú'
        age_restriction: 'Restricción de edad'
        toggle_hidden_recursively: 'Ocultar/Mostrar todos los platos en restaurantes'
        toggle_hidden_restaurant_id: 'Seleccione un restaurante'
        toggle_hidden:
          true: 'Ocultar'
          false: 'Mostrar'
      meta_title:
        label: 'Meta title'
        placeholder: 'meta title'
      meta_description:
        label: 'Meta description'
        placeholder: 'meta description'
    buttons:
      save: 'Guardar'
      delete: 'Eliminar'
      cancel: 'Cancelar'
  reports:
    sidebar:
      report_type: 'Tipo de informe'
      add_filter: 'Añadir un filtro'
      condition_and: 'condición o'
      condition_or: 'condición y'
      remove_filter: 'Eliminar el filtro'
      choose: 'escoja'
      group_by: 'Agrupar por'
      execute_button: 'Ejecutar'
    content:
      loading: 'Generación de Informes.'
      zero_data:
        header: 'Diseñador de informes'
        caption:
          'Seleccione el tipo de informe que desea informar, establezca las condiciones utilizando filtros y haga clic en «Ejecutar»'
  orders:
    sidebar:
      filters:
        reset: 'Reset'
        apply: 'Apply'
        status: 'Estado: '
        restaurant: 'Restaurante: '
        zone: 'Zona: '
        courier: 'Repartidor: '
        date: 'Fecha de entrega: '
        zeroData: 'No se han seleccionado filtros'
        elepsis: 'y otros filtros'
      now: 'Ahora'
      later: 'Después'
      all: 'Todo'
      placeholders: search: 'Búsqueda inteligente'
      sections:
        organization: 'Organización'
        is_bk: 'Eliminar alimentos para los mensajeros'
        status: 'Estado del pedido'
        date_range: 'Período de la entrega'
        separator: 'hasta'
        client_rate: 'Evaluación del cliente'
        restaurants: 'Los restaurantes'
        deliveryZones: 'Las zonas de la entrega'
        assigned_couriers: 'Mensajeros designados'
        order_sources: 'Origen del pedido'
        payment_sources: 'Mtodos de pago'
        payment_status: 'Estado de pago en línea'
        payment_status: 'Estado de pago en línea'
        archive_orders: 'Mostrar los pedidos de más de dos semanas'
        orders_count: 'Pedidos mostrados {{ordersLength}} / {{ordersCount}}'
        delivery_types: 'Tipo de entrega'
      buttons:
        show_limit_orders: 'Mostrar todos los pedidos'
        search_query: 'Esperamos el final de la introducción...'
    table:
      no_number: 'no hay número'
      no_text: 'no se indica'
      assign_courier: 'asignar'
      order_change: 'cambio de'
      content:
        number: "#"
        status: 'Estado'
        published_at: 'Ingresó'
        restaraunt: 'El restaurante'
        client: 'El cliente'
        address: 'La dirección'
        client_rate: 'La evaluación'
        tag: 'Categoría'
        pos_status: 'PdV estado'
        delivery_at: 'Entregar'
        delivery_at_range: '{{day}} de {{from}} a {{to}}'
        courier: 'El mensajero'
        confirmed_by: 'Operador'
        payment_source: 'El pago'
        final_sum: 'Total de los pedidos'
        delivery_price: 'Precio de la entrega'
        source: 'Origenк'
        delivery_zone: 'Zona'
        loading: 'Descargamos los pedidos'
        zero_data:
          archive_not_found: 'No hay ningún pedido'
          archive_limited: 'Muestra está limitada a las últimas dos semanas'
          archive_limited_caption:
            'Para acceder a los pedidos archivados, active el interruptor \'Pedidos de salida anteriores a dos semanas\' en la barra de filtros'
          no_archive: 'No hay los pedidos'
          no_archive_caption: 'Según estos criterios no hay ningun pedido'
  courier_apps:
    header: '¡Es hora de instalar la aplicación de mensajería!'
    comment_start:
      'Parece que ha iniciado sesión como mensajero de Smartomato. Verá los pedidos asignados en la sección'
    orders_button: 'Los pedidos'
    comment_end: ', pero no podrá confirmarlos y gestionar la entrega.'
    setup_application:
      'Para gestionar sus pedidos, instale la aplicación de mensajería para Android o vaya a la interfaz web de gestión de pedidos en línea adaptada para tabletas.'
    button_ios_app: 'Aplicación para iOS'
    button_android_app: 'Aplicación para Android'
    button_mobile_app: 'Interfaz web para tabletas'
    goto_orders: 'Ir a la sección Pedidos'
  clients:
    client_card:
      registered: 'Registrado el {{when}}'
      lastorder: 'Pedido ultimo {{when}}'
      birthdate: 'Cumpleaños {{when}}'
      card: 'Tarjeta de lealtad: №{{number}}'
    clients_count:
      one: 'un cliente'
      few: 'clientes'
      many: 'clientes'
      other: 'clientes'
    bonuses_count:
      one: 'un bono'
      few: 'bonos'
      many: 'bonos'
      other: 'bonos'
    filter:
      smart_search: 'Búsqueda inteligente'
      tags: 'Etiquetas'
      no_tags_message:
        'Todavía no tiene ninguna etiqueta, añadalas a la tarjeta del cliente y defina su categoría.'
      dishes: 'Platos ordenados'
      recurrence: 'Recurrencia'
      order_status: 'Estado del pedido'
      delivery_type: 'Tipo de entrega'
      sources: 'Origenes'
      organizations: 'Las organizaciones'
      cities_restaurants: 'Ciudades (según los restaurantes)'
      unrestricted: 'Sin limitaciones'
      restaurants: 'Los restaurantes'
      order_period: 'El período de pedido'
      average_check: 'Cheque medio'
      orders_count: 'Cantidad de los pedidos'
      black_list: 'La lista negra'
      from: 'desde'
      to: 'hasta'
    index:
      sort_by: 'Ordenar:'
      found: 'Encontrado'
      recurrence_change_dynamics: 'dinámica del cambio de recurrencia'
      percent: 'en porcentajes'
      absolute: 'absolutamente'
      loading: 'Estamos cargando los clientes'
      nothing_found: 'Los clientes no se encontraron'
      nothing_found_comment: 'Trata de cambiar las opciones de filtrado'
    client_type:
      new:
        one: 'nuevo'
        few: 'nuevos'
        many: 'nuevos'
        other: 'nuevos'
      active:
        one: 'activo'
        few: 'activos'
        many: 'activos'
        other: 'activos'
      returned:
        one: 'regresado'
        few: 'regresados'
        many: 'regresados'
        other: 'regresados'
      cold:
        one: 'frio'
        few: 'frios'
        many: 'frios'
        other: 'frios'
      dead:
        one: 'perdido'
        few: 'perdidos'
        many: 'perdidos'
        other: 'perdidos'
    recurrence_filter:
      new: 'Nuevos'
      active: 'Activos'
      returned: 'Regresados'
      cold: 'Frios'
      dead: 'Perdidos'
    recurrence_label:
      new: 'Nuevo'
      active: 'Activo'
      returned: 'Regresado'
      cold: 'Frio'
      dead: 'Perdidoй'
    recurrence_label_long:
      new: 'Cliente nuevo'
      active: 'Cliente activo'
      returned: 'Cliente regresado'
      cold: 'Cliente frio'
      dead: 'Cliente perdido'
    recurrence_comment:
      new: 'El cliente ha hecho el primer pedido.'
      active: 'El cliente ha estado pidiendo regularmente por más de 2 semanas'
      returned: 'El cliente comenzó a pedir de nuevo.'
      cold: 'El cliente no ha pedido por más de 2 semanas'
      dead: 'El cliente no ha pedido por más de 1 mes'
    order_source:
      delivery_club: 'Delivery Club'
      foodfox: 'Yandex.Comida'
      obed_ru: 'Obed.ru'
      broniboy: 'Broniboy'
      chibbis: 'Chibbis'
      glovo: 'Glovo'
      vk: 'Vk'
      sbermarket: 'Sbermarket'
      external_site: 'Sitio externo'
      external_site_mobile: 'Sitio externo (version móvil)'
      marketplace: 'Escaparate'
      marketplace_mobile: 'Escaparate (version móvil)'
      board: 'Board'
      mobile_application_ios: 'Aplicación de iOS'
      mobile_application_android: 'Aplicación de Android'
      iiko: 'iiko'
      wolt: 'Wolt'
      external_aggregator: 'Agregador externo'
      yandex_lavka: 'Yandex.Lavka'
    orders:
      one: 'pedido'
      few: 'pedidos'
      many: 'pedidos'
      other: 'pedidos'
    sort:
      orders_count: 'según del número de los pedidos'
      average_check: 'según del cheque medio'
      created_at: 'según del fecha de registro'
      bonus_count: 'por saldo de bonificación'
  date:
    today: 'hoy'
    tomorrow: 'mañana'
    yesterday: 'ayer'
    by: 'por'
    at: 'a las'
    during: 'durante'
    during_days:
      one: '{{count}} día'
      few: '{{count}} días'
      many: '{{count}} días'
      other: '{{count}} días'
    during_hours:
      one: '{{count}} hora'
      few: '{{count}} horas'
      many: '{{count}} horas'
      other: '{{count}} horas'
    during_minutes:
      one: '{{count}} minuto'
      few: '{{count}} minutos'
      many: '{{count}} minutos'
      other: '{{count}} minutos'
    during_seconds:
      one: '{{count}} segundo'
      few: '{{count}} segundos'
      many: '{{count}} segundos'
      other: '{{count}} segundos'
    week_days: [
      'dom'
      'lun'
      'mar'
      'mié'
      'jue'
      'vie'
      'sáb'
    ]
  billing:
    form:
      settings:
        title: 'Rellenar el cuento'
        caption:
          'Después de la confirmación se le redirigirá a la ventana de pago'
        labels: sum: 'Total'
        buttons:
          pay: 'Pagar'
          cancel: 'Cancelar'
      header: 'Configuración del plan de tarifas'
      set_payment_method: 'Elija un método de pago'
      update_requisites: 'Actualizar los detalles'
      enable_pay_by_card: 'Habilitar el pago con tarjeta'
      enable_pay_by_bank: 'Habilitar el pago a través de cuenta corriente'
      empty_subheader:
        'El plan tarifario afecta a las restricciones asociadas al uso del servicio'
      current_tariff: ' Su tarifa actual «{{tariff}}»'
      unit: 'rub./mes.'
      change_tariff: 'Cambiar la tarifa'
      payment_method: 'Forma de pago de la suscripción'
      change_payment_method: 'Cambiar forma de pago o detalles'
      state:
        normal:
          header: 'Todo está pagado'
          comment: 'Siguiente retiro {{date}}'
        free: header: 'Tarifa gratis'
        invoices:
          header: 'Pagar {{sum}} rub.'
          comment: 'Es necesario pagar antes de {{date}}'
        dept:
          header: 'Pagar {{sum}} rub.'
          comment: 'El servicio estará disponible antes de {{date}}'
        blocked:
          header: 'Organización está bloqueada'
          comment: 'Se ha realizado el bloqueo el {{date}}'
        paywall:
          header: 'Período de prueba'
          comment:
            'Hasta el {{date}} hay un período introductorio. Elija un plan antes de que finalice.'
        paywall_deadline:
          header: 'Período de prueba vencido'
          comment:
            'El período de prueba ha terminado. Elija un plan tarifario para seguir trabajando.'
      choose_tariff: 'Eligir un plan de tarifa'
      choose_tariff_and_setup_payment:
        'Eligir un plan de tarifa y configurar un método de pago'
      pay_button_dept: 'Recargar la cuenta'
      pay_button: 'Pagar'
      operations:
        header: 'Historial de las operaciones de la cuenta'
        table:
          date: 'Fecha'
          operation: 'Operación'
          sum: 'Total'
      balance:
        label: 'En su cuenta'
        currency: 'rub.'
    payment_method:
      tab_card:
        header: 'No se requieren ajustes especiales para el pago con la tarjeta'
        content:
          'Una vez al mes tendrá que seguir el enlace al pago que vamos a enviar y pagar la siguiente cantidad.'
      header: 'Ajuste de su método de pago Smartomato'
      comment:
        'Puede pagar su suscripción a través de su cuenta corriente o tarjeta bancaria'
      tabs:
        card: 'Tarjeta bancaria'
        bank_account: 'Cuenta corriente'
      bank_details:
        header: 'Detalles de organización:'
        payer_name:
          label: 'Nombre de entidad legal'
          placeholder: "LLC 'Los Pollos Hermanos'"
        inn:
          label: 'NIF'
          placeholder: ''
        kpp:
          label: 'Código de concepto de alta fiscal '
          placeholder: ''
        address:
          label: 'Dirección Legal'
          placeholder: 'Requerido para la facturación'
        settlement_account:
          label: 'Cuenta corriente'
          placeholder: ''
        corresponding_account:
          label: 'Cuenta correspondiente'
          placeholder: ''
        bik:
          label: 'BIC'
          placeholder: ''
        bank_name:
          label: 'Nombre del banco'
          placeholder: ''
        signer:
          label: 'Firmante, nombre completo'
          placeholder: 'Ivanov I.I..'
        role:
          label: 'Firmante, posición'
          placeholder: 'CEO'
        act_subheader:
          'Datos para la formación de un acto de servicios prestados'
    tariffs:
      header: 'Elija el plan de tarifa más adecuado para Usted'
      subheader: 'Puede cambiar su plan de tarifa en cualquier momento'
      change_tariff:
        plain: 'Ir a tarifa «{{tariff_name}}»'
        paywall: 'Empezar el uso en el plan de tarifa'
        paywall_before_deadline:
          'Empezar a utilizar el servicio en el plan de tarifa'
    warnings:
      trial_period:
        'Actualmente hay un período de prueba. Seleccione el plan de tarifa antes de {{deadline}}.'
      paywall_warning:
        '{{deadline}} termina el período de prueba. Seleccione el plan de tarifa para evitar el bloqueo.'
      paywall_expired:
        'El período de prueba ha terminado. Seleccione el plan de tarifa para continuar el trabajo.'
      free_tariff:
        'Usted está en un plan gratuito, la recepción de los pedidos en el sitio no está funcionando'
      blocked:
        'La organización está bloqueada debido a la falta del pago, aceptación delos pedidos en el sitio no está funcionando'
      rush_mode_restaurants:
        '🔥 En la parte de los restaurantes inclue un modo de alta demanda: {{disabled}} desde {{total}}'
      blocked_restaurants:
        '🔒 Algunos restaurantes están bloqueados para pedidos: {{disabled}} desde {{total}}'
      dept_detected:
        'Esté en deuda, pague {{sum}} antes del {{deadline}} para evitar el bloqueo'
      pending_invoices:
        'Antes del {{deadline}} necesita pagar {{sum}} para el uso del servicio «Smartomato»'
    notifications: change_tariff_error: 'Error'
  order:
    contact_call_allowed: "Llamada necesaria 📞"
    contact_call_not_allowed: "No llamar ⚠️"
    organization_select_text: 'Elija organización'
    status_mini_popup:
      client_notification_type_call: 'Necesita una llamada al cliente'
      annotation: 'Gestione el progreso de su pedido actual'
      cancel_reason: 'Especifique el motivo de la cancelación'
      placeholders: cancel_reason_comment:
        'Especifique el motivo de la cancelación'
      buttons:
        change_status: 'Cambiar el estatuto'
        open_history: 'Ver la historia de los cambios'
    map_popup:
      warning:
        order_unpaid: '⚠️ EL PEDIDO TODAVÍA NO HA SIDO PAGADO'
        order_expired: '⚠️EL PEDIDO ESTÁ VENCIDA'
      order_name: '№{{order}}'
      takeaway: 'recogida'
      delivery_price: 'encarga {{currency}}'
      delivery_free: 'encarga gratuita'
      payment_source: '{{paymentSource}}'
      choose_self_courier: 'Elegir un mensajero'
      time:
        cooking_start: 'Comenzar a preparar'
        pick_up_at: 'Recoger el pedido'
        delivery_at: 'Encargar el pedido'
        shelf_time: 'Fecha de caducidad del pedido '
      outsource:
        outsource_courier: 'Mensajero asignado'
        no_delivery_request: 'Solicitud de entrega todavía no se ha realizada'
        outsource_courier_pickup_time: 'El mensajero llegará a las:'
        outsource_delivery_price: 'Precio de externalización de la entrega:'
        outsource_messages: 'Mensajes'
      buttons:
        confirm: 'Confirmar el pedido'
        dispose: 'Retirar el pedido'
      client_notification_type_call: 'Necesita una llamada a un cliente'
    courier_mini_popup:
      external_delivery: 'El pedido se subcontrata en {{externalDelivery}} '
      selected_courier:
        courier_free: 'El mensajero está libre'
        distance: 'Distancia hasta al restaurante'
        order_number: 'El pedido №{{order}}'
        no_address: 'sin dirección'
        picked_up_at: 'Recogío a las'
        pick_up_at: 'Tiempo de la recogida del mensajero (según el plan)'
        delivery_at: 'Encarga a las'
      annotation:
        choose_self: 'Seleccione el mensajero queíen entregará el pedido'
        non_created_outsource:
          'Aplicación para la entrega externa en {{externalDelivery}} no ha sido creada'
        confirm_create_outsource:
          'Confirme la colocación de la solicitud en {{externalDelivery}}'
        cancel_courier_assign:
          'Haga clic en la segunda vez en la línea de mensajería para eliminar su asignación'
        external_courier:
          'Si continúa, la externalización a {{externalDelivery}} será cancelado.'
        self_courier: 'Puede hacer un pedido a su mensajero.'
        cancel_self_before_place:
          'Para realizar un pedido de externalización a {{externalDelivery}} - eliminarlo de su propio mensajero'
        error: 'Error'
      buttons:
        back: 'detrás'
        cancel_outsource_delivery: 'Confirmar cancelación de externalización'
        cancel: 'Cancelación'
        place_outsource: 'Presentar una solicitud'
    time_mini_popup:
      annotation:
        'Especifique los intervalos de tiempo para el procesamiento de los pedidos'
      section:
        cooking_start_at: 'Empezar a preparar'
        pick_up_at: 'Recoger el pedido'
        delivery_at: 'Encargar el pedido'
      buttons: confirm: 'Confirmar el pedido'
      takeaway: 'recogida'
      order_name: 'Pedido #{{order}}'
      payment_source: '{{paymentSource}}'
      time:
        cooking_start: 'Empezar a preparar'
        delivery_at: 'Encargar el pedido'
    feasibility_warnings:
      transportation_time:
        'Es posible que el pedido no SE ENTRGUE a tiempo.. Necesitaba {transportation_time}} min., pero Usted tiene {{trans_time}} min.'
      cooking_time:
        'Es posible que el pedido no ESTÉ LISTO a tiempo. Necesitaba {transportation_time}} min., pero Usted tiene {{trans_time}} min.'
    problems:
      is_past_delivery_end_deadline: 'El pedido no fue entregado a tiempo.'
      is_past_delivery_start_deadline:
        'El pedido no fue entregado al mensajero a tiempo.'
      is_past_cooking_end_deadline: 'El pedido no fue preparado a tiempo'
      is_past_cooking_start_deadline: 'La preparación no comenzó a tiempo'
      is_past_confirm_deadline: 'El pedido no fue confirmado a tiempo'
      is_past_payment_deadline: 'El pedido todavía no ha sido pagado'
      is_past_courier_deadline: 'Mensajero no fue asignado a tiempo'
      is_past_restaurant_confirm_deadline:
        'El restaurante no confirmó el pedido.'
    payment_method:
      cash: 'en efectivo'
      card: 'con tarjeta online'
      courier_card: 'con tarjeta al mensajero'
      delivery_club_card_online: 'en el sitio web de DeliveryClub'
      external_service_card_online: 'online en un servicio externo'
      extra_bonuses: ' + bonos'
    pos_status:
      pending: 'Exportación pendiente'
      error: 'Error de exportación'
      success: 'Éxito de las exportaciones'
    payment_status:
      paid: 'está pagado'
      unpaid: 'no está pagado'
    delivery_type:
      takeaway: 'recogida'

      # TODO translate from english
      delivery: 'entrega de mensajería'
      dine_in: 'dine-in'

    asap_type:
      specified_time: 'por un tiempo determinado'
      asap: 'lo antes posible'
    status:
      draft: 'Borrador'
      pending: 'Nuevo'
      confirm: 'Está confirmado'
      preparing: 'Está siendo preparado'
      prepared: 'Está preparado'
      delivery: 'Mensajero lo tiene'
      complete: 'Está encargado'
      undo: 'Está cancelado'
    scheduled: 'Está fijado a {{when}}'
    takeaway: 'Recogida'

    # TODO translate from english
    dine_in: 'Dine-in'

    bonus_card:
      title: 'Bonos y descuentos'
      discount: 'Descuento por un pedido'
      bonus_dish: 'Elija un plato:'
    content: edit: item_free: 'como un regalo'
    summary:
      items_sum: 'pedido'
      delivery_price: 'encarga'
      used_bonuses: 'puntos de bonificación'
      discount_sum: 'discuento'
      commission_sum: 'comisión'
      service_charge_amount: 'cargo por servicio'
    edit:
      configurator:
        comment: 'comentario'
        labels: total_price: 'Total'
        placeholders: comment: 'Deseos adicionales'
      order_now_viewing: 'El pedido se está viendo actualmente: '
      draft_status_notice:
        'No puede gestionar el estado del borrador del pedido. Utilice el botón «colocar» para transferir el pedido al estado «nuevo»'
      normal_header: 'Pedido #{{number}}'
      draft_header: 'El borrador del pedido'
      order_content_header: 'Contenido del pedido'
      published_at: 'publicado a las {{when}}'
      reset_change: '¿No necesita el cambio?'
      address_warning: 'No se identificó claramente el número de la casa'
      pos_error:
        label: '⚠️ Error al enviar al POS'
        retry_export_disabled: '⛔ Límite de reenvío de pedido alcanzado'

      client_search: 'Busqueda del cliente...'
      new_client: 'Este cliente aún no está en su base de datos'
      edit_order: 'editar'
      finish_editing: 'terminar'
      delete_confirm: '¿Está seguro de que desea eliminar el pedido?'
      payment:
        warning: '⚠️ El pedido todavía no ha sido pagado.'
        success: '✅El pedido ha sido pagado'
      sync:
        synced: 'Pedido fue guardado a las {{when}}'
        syncing: 'Guarda...'
        error: '¡Error de guarda!'
      history:
        empty_history: 'no hay un historial de los cambios'
        loading_text: 'Carga de historial...'
      delivery_zone:
        minimal_order_price: 'Pedido mínimo:'
        delivery_time: 'Hora de entrega: '
        free_delivery_price: 'Entrega gratuita desde:'
        time_unit: ' min.'
        delivery_price: 'Precio de entrega:'
      labels:
        status: 'Estado'
        restaurant: 'Restaurante'
        comment: 'Comentario'
        change: ' Se necesita el cambio de'
        use_bonuses: 'Pagar con los bonos'
        payment: 'Pago'
        qr_payment_status: 'Estado de pago vía QR'
        takeaway: 'Punto de recogida'
        when_delivery: 'Entregar'
        when_pickup: 'Recoger el pedido'
        client_delivery_at: 'Cuando entregar el pedido al cliente'
        cooking_start_at: 'Cuando empezar a preparar'
        # TODO translate from english
        table: 'Table'

        delivery_at: 'Cuando entregar'
        pick_up_at: 'Cuando recoger del restaurante'
        client:
          phone: 'Teléfono'
          name: 'Nombre'
          rate: 'Evaluación del cliente'
        delivery_type: 'Tipo de entrega'
        city: 'Ciudad'
        delivery_address: 'Dirección de entrega'
        delivery_zone: 'Zona de entrega'
        delivery_price: 'Precio de entrga'
        use_promo_code: 'Especificar código de promoción'
        used_promo_code: 'Código de promoción se ha sido utilizado'
        courier: 'Mensajero'
        use_delivery: 'Entregar'
        tag: 'Categoría'
        pos_status: 'PdV estado'
        staff_comment: 'Comentario del personal'
        cutlery: 'Número de los cubiertos'
      buttons:
        add_dish: 'Añadir un plato'
        close: 'Cerrar'
        place: 'Hacer'
        more_details: 'mostrar más detalles'
        only_statuses: 'mostrar solo estados'
      placeholders:
        address: 'DIRECCIÓN'
        apartment: 'apartamento'
        floor: 'planta'
        staircase: 'entrada'
        address_comment: 'comentarios a la dirección'
        buddy_name: 'Introduzca el nombre'
      hints: geocode_order: 'Definir zona de entrega'
      dish_selection:
        title: 'Elija un plato'
        nothing_found: 'Nada se ha encontrado'
        is_hidden: 'Oculto en rl menú'
        buttons: back: 'volver'
        placeholders: search: 'Busqueda del plato'
      bonus_amount:
        none: ''
        one: 'Disponible para su uso: {{count}} punto de bonificación'
        few: 'Disponible para su uso: {{count}} puntos de bonificación'
        many: 'Disponible para su uso: {{count}} puntos de bonificación'
  monitor:
    notifications:
      common_title: 'Pedido #{{number}} — {{name}}'
      new_order_title: 'Nuevo pedido ha sido recibido#{{number}}'
      paid: 'Pedido #{{number}} ha sido pagado'
      confirm_deadline:
        'El pedido llegó a las {{when}} pero todavía no se ha confirmado'
      cooking_start_deadline:
        'El pedido debería haber comenzado a prepararse a las {{when}}, pero todavía está en el estado {{status}}»'
      cooking_end_deadline:
        'El pedido debería haberse cocinado {{cuando}}, pero todavía está en el estado «{{status}}»'
      delivery_start_deadline:
        'Se suponía que el pedido estaría con el servicio de mensajería a las {{when}}, pero aún está en el estado «{{status}}»'
      delivery_end_deadline:
        'Se suponía que el pedido se entregaría a las {{when}} pero aún está en estado «{{status}}»'
      payment_deadline: 'El pedido no ha sido pagado todavía'
      courier_deadline:
        'Recogida del pedido en el restaurante a las {{when}} y el mensajero aún no se ha asignado'
      status_changed: 'Pedido se ha movido al estado «{{status}}»'
      courier_confirmed: 'El mensajero {{courier_name}} confirmó el pedido'
      restaurant_confirmed:
        'Confirmación del pedido se ha recibido del restaurante {{restaurant_name}}'
      just_created: 'Confirme el pedido a las {{when}}'
      restaurant_confirm_deadline:
        'El pedido todavía no ha sido confirmado por el restaurante.'
      cooking_start:
        'Empezar a preparar. Recogida del pedido del restaurante a las {{when}}'
      active_order:
        'Pedido pendiente devuelto al trabajo, entrega a las {{when}}'
      delayed_order: 'El pedido se ha movido a la categoría pendiente.'
  configurator:
    confirm:
      remove_group_binding: '¿Quitar el enlace del grupo?'
      remove_modifier_scheme: '¿Quitar el configurador de platos?'
    validations:
      single_select: '{{groupName}}: Necesita elegir exactamente una opción'
      multiple_select:
        '{{groupName}}: necesita elegir entre las opciones {{min}} a {{máx}}'
  currency: '{{price}} rub.'
  dashboard:
    sidebar:
      done_title: 'Preparar el sitio web del restaurante para su lanzamiento'
      done_caption:
        '¡Excelente! Su sitio está listo para el lanzamiento. Pronto le diremos cómo aumentar las ventas y aumentar la eficiencia.'
      header: 'Prepare el sitio web del restaurante para el lanzamiento'
      progress: 'Se ha cumplido {{done}}/{{total}}'
    main:
      restaurant_multiselect: 'Mostrar datos de todos los restaurantes disponibles'
      zero:
        title: 'Estadísticas del restaurante'
        text:
          'Hasta ahora no tenemos información suficiente para mostrar la dinámica de ventas reales, las cargas máximas y los pedidos de mapas de frecuencia'
        disclaimer: 'Datos de demostración'
      range:
        week: 'Semana'
        month: 'Mes'
        year: 'Año'
    dynamics:
      orders_summary:
        one: 'pedido'
        few: 'pedidos'
        many: 'pedidos'
        other: 'pedidos'
      revenue: 'ingresos totales'
      average_check: 'cheque promedio'
      header: 'Dinámica de los pedidos'
      pie_chart_caption: 'La estructura de los clientes según el retorno'
      bar_chart:
        header: 'Picos de carga durante el día'
        work_days: 'Días de semana'
        weekends: 'Fines de semana'
        whole_week: 'Toda la semana'
      baskets:
        map_header: 'Mapa de los pedidos'
        dishes_header: 'Platos populares'
        loading: 'Cargando datos...'
        dish_unit: 'cosas.'
  sm_select:
    placeholder:
      zero: 'Nada se ha elegido'
      one: '{{count}} elemento elegido'
      few: '{{count}} elementos elegidos'
      many: '{{count}} elementos elegidos'
      other: '{{count}} elementos elegido'
  staff:
    roles:
      admin: 'Administrador'
      regional_admin: 'Administrador regional (franquiciado)'
      manager: 'Gerente'
      manager_logist: 'Gerente de Logistica'
      logist: 'logístico'
    notifications:
      order_created: 'Pedido nuevo'
      order_restaurant_confirmed:
        'Aceptación del pedido por la parte del restaurante'
      order_courier_confirmed: 'Confirmación del pedido por la mensajería'
      order_cooking_start: 'Llegada del pedido a la cocina'
      billing_event: 'Pago por los servicios de Smartomato'
      negative_rate_received:
        'Obtención de una evaluación negativa por un pedido'
      restaurant_running_changed: 'Encender o apagar el restaurante'
      pos_order_export_error: 'Recibir errores al enviar un pedido al cajero'
      client_message_created: 'Mensaje entrante del cliente'
    communication_channel_updated: 'Actualización del estado del canal'
  staff_table:
    is_me: 'Es Usted'
    in_restaurant: 'en el restaurante'
  checklist:
    theme_selected: 'Elija un diseño de sitio web'
    menu_filled: 'Añade algunos platos'
    has_delivery_zones: 'Especifique la zona y los términos de la entrega'
    has_couriers: 'Сonecte a los mensajeros'
    has_address_phone:
      'Introducqa el número de teléfono y la dirección del restaurante.'
    has_domain: 'Elija un dominio'
    is_published: 'Publique un sitio'
  menu:
    channels: 'Canales'
    static_pages: 'Páginas'
    sandbox: 'UI'
    organizations: 'Organizaciones'
    analytics: 'Analítica web y SEO'
    restaurants: 'Restaurantes'
    couriers: 'Mensajeros'
    delivery: 'Encarga'
    dishes: 'Menú'
    themes: 'Sitio'
    mobile_app: 'Aplicación móvil'
    orders: 'Pedidos'
    billing: 'Plan tarifario'
    profile: 'Сonfiguración de perfil'
    business_role: 'Funciones empresariales'
    staff: 'Empleados'
    sip: 'Telefonía'
    support: 'Apoyo'
    clients: 'Clientes'
    promos: 'Promociones'
    map: 'Mapa'
    organization_settings: 'Configuración de la organización'
    organization_settings_header: 'Configuraciones'
    payment_methods: 'Métodos de pago del pedido'
    integrations: 'Integraciones'
    integrations_settings:   'Configuración de integraciónes'
    logout: 'Salir'
    utilities: 'Utilidades'
    interface: 'Configuración de la interfaz'
    reports: 'Informes'
    promo_constructor: 'Promociones'
    loyalty_programs: 'Programas de fidelización'
    bonus_categories: 'Categorías de bonificación'
    ads_and_push: 'Publicidad y mailing'
    banners: 'Banners'
    client_tags: 'Etiquetas'
  login:
    please_authorize: 'Ingrese, por favor'
    login_placeholder: 'Login'
    password_placeholder: 'Contraseña'
    sign_in: 'Iniciar sesión'
    cant_login: '¡Error al iniciar sesión!'
    label_restore_password:
      'Ingrese su dirección de correo electrónico a la que le enviaremos un correo electrónico con instrucciones para restablecer su contraseña'
    mail: 'Correo electrónico'
    send_password: 'Enviar contrseña'
    cancel: 'Cancelar'
    login: 'Login'
    password: 'Contraseña'
    password_restore_was_send:
      'Se ha enviado un correo electrónico con instrucciones para restablecer la contraseña a su correo electrónico'
    captcha_error: '¡Error! Confirme que no es un robot.'
    sign_up_link: 'Registrese,'
    sign_up_link_comment: 'si no tiene una cuenta'
    restore_button: '¿Olvidó su contraseña?'
  notifications:
    organization_saved:
      title: 'Guardado'
      message: 'La organización se ha guardado correctamente.'
    restaurant_saved:
      title: 'Guardado'
      message: 'El restaurante se ha guardado correctamente.'
    restaurant_error:
      title: 'Error'
      message_fallback: 'Ocurrió un error al guardar el restaurante'
    restaurant_destroy_error:
      title: 'La eliminación no es posible'
      message_fallback:
        'Compruebe que este restaurante no contiene las zonas de entregas y pedidos'
  categories:
    published_at: 'Publicado por última vez el {{date}} a las {{time}}'
    not_published: 'El menú todavía no ha sido publicado.'
    publish: 'Publicar un menú'
    add_category: 'Añadir una categoría'
    edit_placeholder: 'Ingrese su nombre'
    upload_photo: 'Subir una foto'
    delete_category: 'Eliminar una categoría'
    add_dish: 'Añadir un plato'
    zero_data:
      header: 'Categoría no se ha sido eligida'
      caption:
        'Elija una categoría para ver información detallada o comenzar a editar.'
    editConfigurator: 'Ajustes del configurador'
    search: 'Buscar'
    confirm:
      save_before_photo: 'Es necesario guardar la categoría antes de subir la foto. ¿Ahorrar?'
      delete: '¿Eliminar categoría? Todos los platos de la categoría serán eliminados.'
    new_configurator:
      categories: 'Categorías'
      modifiers: 'Modificadores'
      help:
        'Modificadores son las características de los platos que les agregan una determinada propiedad o característica de la cocción (por ejemplo, «sin sal», «con limón», etc.).<br> <br> Los modificadores son convenientes para usar como un constructor para un almuerzo de negocios, hamburguesas o fideos en una caja'

  dish_groups:
    title: 'Configuración de Combos'
    new_group: 'Nuevo Combo'
    dish_group:
      header: 'Lista de Platos'
      comment: 'Especifique la lista de platos posibles'
    zero_data:
      title: 'No se han creado combos'
      caption: 'Agregue combos para ofrecer a sus clientes la oportunidad de crear combinaciones únicas de platos. Un ejemplo de combo podría ser un almuerzo ejecutivo.'
    buttons:
      add: 'Agregar'
      edit: 'Editar'
    help: 'Los combos son una forma conveniente de crear un conjunto de platos que se complementan perfectamente. Por ejemplo, puede crear un almuerzo ejecutivo seleccionando su sopa, ensalada y plato principal favoritos, u ordenar un conjunto de 5 pizzas con una variedad de sabores para un grupo.
          <br>
          <br>
          Los combos le permiten crear soluciones personalizadas que se adaptan a cualquier gusto y ocasión.'

  modifier_groups:
    zero_data:
      title: 'No hay configuraciones creados'
      caption:
        'Añada una configuración para darle al cliente la posibilidad de seleccionar opciones de platos. Un ejemplo de configuración podría ser una elección de salsa, aderezo o tamaño de la porción.'
    buttons:
      add: 'Añadir'
      edit: 'Editar'
    condition:
      minmax: 'Requisito de cantidad'
      view_type: 'Mostrar como'
      prompt: 'Formulario de incentivos'
    title: 'Ajustes de los modificadores'
  delivery:
    menu:
      couriers: 'Mensajeros'
      zones: 'Zonas de entrega'
      own_couriers: 'Mensajeros propios'
    outsource:
      statuses:
        canceled: 'Está cancelado'
        idle: 'Sin aplicación'
        claim_created: 'Busqueda del mensajero'
        courier_assigned: 'El mensajero ha sido asignado'
        delivering: 'Entrega en curso'
        delivered: 'Está entregado'
        problem: 'Un problema'
        pickup_arrived: 'El mensajero ha llegado'
    zone:
      providers:
        own: 'No'
        dostavista: 'Dostavista'
        yandex_go: 'Yandex Delivery'
        broniboy: 'Broniboy'
        dc_last_mile: 'DC Last Mile'
        sber_last_mile: 'Sber Last Mile'
    notifications:
      ymaps:
        title: 'Mapas Yandex'
        message: 'El token de Yandex está bloqueado o no está disponible'

  restaurants:
    tarif_restriction:
      title: 'Se excedió el límite del restaurante'
      message: 'Cambie su plan tarifario o apague establecimientos irrelevantes'
    add_restaurant: 'Añadir un restaurante'
    no_group: 'Sin grupo'
    remove_button: 'Eliminar'
    cancel_button: 'Cancelar'
    save_button: 'Guardar'
    remove_confirm: '¿Eliminar el restaurante?'
    cancel_confirm: '¿Cancelar los cambios?'
    validate_name_phone_address:
      '¡El nombre, el número de teléfono y la dirección no deben estar vacíos!'
    zero_data:
      message: 'Restaurante no ha sido eligido'
      hint:
        'Seleccione un restaurante para ver los detalles o comenzar a editar.'
    edit:
      is_new: 'Añadir un restaurante nuevo'
      form_title: 'Complete el siguiente formulario y haga clic en Guardar'
      normal_mode_text: 'Modo normal ha sido activado'
      normal_mode_caption:
        'Se utilizarán los ajustes estándar de la zona de entrega'
      not_running: 'El establecimiento no funciona'
      not_running_caption:
        'Actíve para empezar a aceptar los pedidos para este establecimiento.'
      common_destroy: 'Supresión común'
      common_destroy_caption: 'Habilitar para borrar a la fuerza el restaurante.'
      force_destroy: '⚠️ Supresión forzosa ⚠️'
      force_destroy_caption: 'Tenga en cuenta que, en caso de eliminación forzosa, también se eliminarán todos los pedidos y zonas de entrega relacionados con este restaurante.<br>
                              ¡Sin posibilidad de recuperación!'
      timezone_caption: '⚠️ La organizacion tiene el {{timezone}}'
      off_reason_caption:
        'En este campo puede especificar el motivo del cierre del restaurante'
      auto_enable_timezone:
        'Cuando llegue la hora especificada, los pedidos para este restaurante se habilitarán automáticamente y los gerentes recibirán una notificación por correo electrónico.'
      labels:
        name: 'Título'
        phone: 'Teléfono'
        address: 'Dirección'
        city: 'Ciuada'
        description: 'Descrpción'
        availability: 'Disponibilidad del pedido'
        rush_mode: 'Modo de alta demanda'
        is_delivery: 'Modo de trabajo'
        deletion: 'Supresión'
        location: 'Ubicación'
        timezone: 'Zona horaria del restaurante'
        external_id: 'Código externo'
        terminal_id: 'ID de terminal'
        order_number_prefix: 'Prefijo del número de pedido'
        off_reason: 'Motivo del cierre'
        auto_enable: 'Cuándo activar automáticamente el restaurante'
        address_comment: 'Comentarios a la dirección'
        parent_restaurant: 'Restaurante principal'
        timetables: 'Horario de Atención'
      placeholders:
        name: 'Ingrese el nombre '
        phone: 'Ingrese el número de telefóno'
        address: 'Ingrese el nombre de la calle'
        city: 'Ingrese la ciudad '
        location:
          'Si necesita una explicación de la dirección (utilizada cuando se integra con una subcontratación de entrega)'
        timezone: 'Zona horaria del restaurante'
        external_id: 'Necesita para la integración con servicios externos'
        terminal_id: 'Necesita para la integración con servicios externos'
        order_number_prefix: 'Anulación del prefijo de un pedido'
        off_reason: 'Especifique el motivo'
        description:
          'Descripción de la página del restaurante en la aplicación y en el sitio web'
        address_comment:
          'Si necesita una explicación de la dirección (utilizada cuando se integra con una subcontratación de entrega)'
      is_running: 'El establecimiento funciona'
      is_running_caption:
        'Cancele para dejar de tomar pedidos a este establecimiento. Restaurantes desconectados no cuentan en las restricciones arancelarias.'
      rush_mode_text: '🔥 Modo de alta demanda ha sido activado'
      rush_mode_caption:
        'Se utilizarán ajustes especiales para este modo desde la zona de entrega'
      default_for_city_text: 'Seleccionar por defecto'
      default_for_city_caption: 'Este restaurante se seleccionará por defecto al elegir una ciudad'
      is_delivery_text: 'Mostrar la dirección a los clientes'
      is_delivery_hint:
        'Deactive este cartel si el restaurante funciona solo para la entrega y los clientes no necesitan saber su dirección. En este caso verá el establecimiento en el mapa, y los clientes verán solo el número de teléfono.'
  organizations:
    add_button: 'Añadir'
    delete_button: 'Elomonar'
    cancel_button: 'Cancelar'
    save_button: 'Guardar'
    validate_name_host: '¡El nombre y el host no deben estar vacíos!'
    cancel_confirm: '¿Cancelar los cambios?'
    remove_confirm: '¿Eliminar´la organización?'
    zero_data:
      message: 'Organización no ha sido seleccionada'
      hint:
        'Seleccione una organización para ver información detallada o comenzar a editar.'
    name:
      label: 'Título'
      placeholder: 'Ingrese '
    phone:
      label: 'Teléfono'
      placeholder: 'Ingrese el número de telefóno'
    host:
      label: 'Dominio'
      placeholder: 'Ingrese un subdominio *.smartomato.ru'
    login:
      label: 'Ingrese login'
      placeholder: 'Login'
    password:
      label: 'Contraseña'
      placeholder: 'Ingrese contraseña'
    about:
      label: 'Descripción'
      placeholder: 'Descripción'
  zone_templates:
    header: 'Añadir un requisito de la entrega a'
    switch:
      delivery: 'Entrega'
      takeaway: 'Recogida'

    # TODO translate from english
      dine_in: 'Dine-in'

    # TODO translate from english
    new_object_default_name:
      dine_in: 'Dine-in conditions'
      delivery: 'New delivery zone'
      takeaway: 'Takeaway point'

    header_description:
      'Puede añadir las zonas de entrega de mensajería o los puntos de recogida'
    draw_description:
      'Si ninguna de las zonas preestablecidas le conviene, puede dibujar la suya propia'
    draw_description_no_templates:
      'Utilice el mapa para establecer la región de la zona'
    draw_button: 'Dibuar una zona'
    choose_zone_header: 'Utilice una de las plantillas.'
    choose_zone_placeholder: 'Busqueda'
    nothing_found: 'Zona no ha sido encontrada'
    draw_zone_header: 'Dibuje una zona en el mapa'
    add_takeaway: 'Crear un punto de recogida'
    takeaway_note:
      'Para crear un punto de recogida en este restaurante, debe establecer las condiciones de trabajo, como el pedido mínimo, el modo de funcionamiento del punto y el tiempo de cocción.'

    # TODO translate from english
    dine_in_note: 'To enable dine-in in this restaurant you should set the conditions: the restaurant\'s working hours and some other parameters'
    add_dine_in: 'Add dine-in conditions'

  orders_map:
    no_current:
      title: 'No hay pedidos actuales'
      text:
        'Esto incluirá nuevos pedidos o pedidos que necesitan ser procesados.'
    no_delayed:
      title: 'No hay pedidos pendientes'
      text: 'Esto incluirá órdenes que aún no requieran su intervención.'
    courier_popup:
      statuses:
        offline: 'No funcciona'
        free: 'Libre'
        delivering:
          'Está entregando un pedido a la direción <strong>{{address}}</strong>'
        picking_up_order:
          'Está dirigiendose para recoger el pedido a <strong>{{restaurant}}</strong>'
  history:
    change_name:
      delivery_price: 'Precio de la entrega '
      delivery_at: 'Hora de la entrega'
      cooking_start_at: 'Comienzo de preparación'
      status: 'Estado'
      courier_id: 'Mensajero'
      pick_up_at: 'Hora de recogida'
      contact_name: 'Título'
      contact_phone: 'Teléfono'
  import:
    status:
      free: 'Libre'
      upload: 'Subir'
      queued: 'Puesto en cola'
      working: 'Está realizando'
  modifier_group:
    new_group: 'Nuevo grupo de modificadores'
    edit:
      back_button: 'Volver'
      header: ''
      subheader: 'Grupo de modificadores'
      photo:
        label: "Foto del modificador"
        upload: "Cargar foto"
      name:
        label: 'Título'
        placeholder: 'Nombre de modificadores'
      visible: label: 'Mostrar'
      prompt:
        label: 'Sugerencia de uso'
        placeholder: 'Por ejemplo, «Seleccione un asado»'
      minmax: label: 'Límite de cantidad'
      min:
        label: 'No menos que'
        placeholder: '-'
      max:
        label: 'No mas que'
        placeholder: '-'
      view_type:
        label: 'Mostrar como'
        checkbox: 'Checkbox'
        select: 'Select'
        stepper: 'Stepper'
      external_id:
        label: 'Exterior ID'
        placeholder: 'ID'
      modifiers:
        new_modifier: 'Modificador nuevo'
        restaurant_price: 'Precio en {{restaurant}} ({{priceUnit}})'
        header: 'Grupo de modificadores'
        comment: 'Especifique una lista de opciones posibles'
        default: 'Predeterminado'
        name:
          label: 'Título'
          placeholder: 'Por ejemplo, «Medium rare»'
        price:
          label: 'Precio'
          placeholder: '—'
        external_id:
          label: 'Exterior id'
          placeholder: '—'
      buttons:
        save: 'Guardar'
        delete: 'Eliminar'
        cancel: 'Cancelar'
        add: 'Añadir un modificador'

    availability:
      title: 'Disponibilidad de modificadores en el restaurante'
      caption: 'Aquí puedes ocultar el modificador del menú del restaurante'
      loading: 'Cargando'

  general_parameters:
    labels:
      site_name: 'El sitio está disponible en'
      site_name_caption:
        "Puede cambiar la dirección del sitio en la sección 'Configuración de la organización'"
      organization_logo: 'Logo'
      organization_name: 'Nombre de la organización'
      organization_about: 'Descripción de la organización'

  static_pages:
    header: 'Lista de páginas'
    zero_data:
      search: 'No hay páginas disponibles'
    table:
      content:
        name: 'Título'
        slug: 'URL'
        position: 'Posición'
        show_in_app: 'Visible en la Aplicación'
        show_in_web: 'Visible en el Sitio Web'
        page_type: 'Tipo de Página'
      types:
        html: 'HTML'
        collection: 'Colección'
      filters:
        visibility: 'Visibilidad'
    edit:
      header: 'Editar Página'
      subheader: 'Complete el formulario a continuación y haga clic en guardar, por favor'
      photo:
        label: 'Foto de la Página Hija'
        placeholder: 'Foto de la Página Hija'
      title:
        label: 'Título'
        placeholder: 'Título de la Página Hija'
      excerpt:
        label: 'Descripción Corta'
        placeholder: 'Descripción Corta de la Página Hija'
      name:
        label: 'Título'
        placeholder: 'Título de la Página'
      slug:
        label: 'Ruta'
        placeholder: 'Ruta de la Página'
      position:
        label: 'Orden de Visualización'
        placeholder: 'Orden de Visualización'
      content:
        label: 'Contenido de la Página'
      parent:
        label: 'Página Principal'
        placeholder: 'Seleccione una Página Principal'
      childs:
        label: 'Páginas Secundarias'
        placeholder: 'Seleccione Páginas Anidadas'

  promos:
    table:
      content:
        name: 'Nombre'
        is_working: 'Activa'
        actual_till: 'Periodo de Validez'
        restaraunt: 'Restaurantes'
        sources: 'Fuentes'
        priority: 'Prioridad'
        visibility: 'Visibilidad'
      filters:
        is_active:
          label: 'Activa'
          active: 'Sí'
          not_active: 'No'
        date_range: 'Periodo de Validez de la Promoción'

    confirm: delete: '¿Eliminar la promoción?'
    buttons: add: 'Añadir'
    zero_data:
      active: 'Aún no hay promos activas'
      archive: 'Aún no hay promos de archivo '
    zero_data_caption:
      active: 'Añada promo para aumentar la frecuencia promedio de los cheques o los pedidos'
      archive: 'Añada promo para aumentar la frecuencia promedio de los cheques o los pedidos'

    edit:
      back_button: 'Volver'
      header: 'Editar las promociones'
      subheader:
        'Rellene el siguiente formulario y haga clic para guardar, por favor'

      menu:
        main: 'Información total'
        conditions: 'Condiciones'
        bonuses: 'Bonificaciones'

      name:
        label: 'Título'
        placeholder: 'Título de la promoción'
      description:
        label: 'Descripción'
        placeholder: 'Descripción'
      offer_description:
        label: 'Sugerencia del uso'
        placeholder:
          'El texto que será visible para el cliente si la promoción está disponible'
      is_working:
        label: 'Promoción activa'
        caption:
          'Le permite desactivar temporalmente la acción de promoción. Las promociones inactivas no se mostrarán a los clientes.'
      period:
        label: 'Validez'
        to: 'Hasta'
      for_birthday:
        label: 'Promoción de cumpleaños'
        before_birthday: 'Activa hasta tu cumpleaños'
        after_birthday: 'Activo después de su cumpleaños'
        placeholder: 'número de días'
        caption: 'La promoción de cumpleaños puede activarse un número determinado de días antes y después del cumpleaños'
      timetable:
        enabled: 'Horario está activado'
        disabled: 'Horario está disactivado'
      timetable_for_order_time:
        label: 'Tener en cuenta la hora del pedido'
        caption: 'El horario establecido se aplicará a la hora en que se realiza el pedido, no a la hora en que se realiza el pedido'
      timetable_for_asap_only:
        label: 'Tener en cuenta sólo la hora del pedido para pedidos urgentes'
        caption: 'En el caso de una orden pendiente, se utilizará la hora a la que se realiza la orden en lugar de la hora a la que se realiza'
      priority:
        label: 'Prioridad de las promociones'
        placeholder: 'Número entero positivo'
        caption:
          'Se necesita prioridad para controlar cómo se resumirán las promociones.<br> Si varias promociones son adecuadas para el huésped, se seleccionará una o más con la prioridad más alta.'
      is_exclusive:
        label: 'La promoción es mutuamente excluyente'
        caption: 'Permite prohibir el uso de varias promociones con la misma prioridad en una misma orden.'
      sources:
        label: 'Limitación en las fuentes de los pedidos'
        unrestricted: 'La promoción es aplicable a todas las fuentes del pedido'
        restricted_header: '¡Preste atención!'
        restricted_comment:
          'Debido a la limatación en las fuentes del pedido, la promoción estará disponible para los clientes solo cuando el pedido es de las fuentes enumeradas'
      restaurants:
        label: 'Limitación de los restaurantes'
        unrestricted: 'La promoción funcionará para todos los restaurantes'
        restricted_header: '¡Preste atención!'
        restricted_comment:
          'Debido a la limitación de los restaurantes, la promoción aparecerá para el cliente solo después de que se determine el restaurante (después de ingresar la dirección o elegir un punto de recogida)'
      inversed_delay: 'Apagada por defecto'
      disposable: 'Desechable'
      for_referral: 'para invitado (referral)'
      is_takeaway: 'Adecuado para recogida'
      is_delivery: 'Adecuado para la entrega'
      is_dine_in: 'Adecuado para cenar en un restaurante'
      free_delivery: 'Envío gratis'
      not_delivery_takeaway_warning:
        'Para que la promoción funcione, debe ser adecuado para al menos un método de recepción de un pedido'
      disable_bonus_getting: "No acumular puntos"
      disable_bonus_usage: "No canjear puntos"
      last_order:
        header: '«Último pedido»'
        comment:
          'Puede realizar una promoción que funcionará para los huéspedes que realizaron al menos un pedido para el número especificado de días pasados por un total no menos que el especificado'
        days_count:
          label: 'Cantidad de dias:'
          placeholder: 'cantidad de dias:'
        sum:
          label: 'Total mínimo del pedido:'
          placeholder: 'Total'
      single_use_codes:
        header: 'Códigos promocionales únicos'
        comment:
          'En una promoción, puede definir un conjunto de los códigos que la activarán. Cada código solo se puede utilizar una vez.'
        enabled:
          label: 'Códigos promocionales únicosы'
          caption:
            'Puede crear un conjunto de los códigos secretos, cada uno de los cuales se puede usar solo una vez'
        stat:
          label: 'Número de códigos añadidos a la promoción'
          report: 'Informe del uso de los códigos'
          download: 'Descargar los códigos (.csv)'
          used: 'de los cuales ya se han sido utilizados'
          available: 'Disponible para el uso'
          delete_unused: 'Eliminar los códigos que no eran utilizados'
        create:
          title: 'Generar los códigos promocionales'
          title_more: 'Generar los códigos promocionales adicionales'
          amount: 'Cantidad'
          length: 'Longitud del código'
          button: 'Generar'
          comment:
            'Puede crear un grupo de los códigos a la vez de acuerdo con ciertas reglas, especifique cuántos códigos necesita y cuántos caracteres deben tener. Cuantos más caracteres, menor es la posibilidad de que el cliente pueda recogerlos, pero más difícil es ingresarlos.'
          generate: 'Generar los códigos'
          cancel: 'No generar los códigos'
          need_save:
            'La generación estará disponible después de guardar la promoción.'
      promos_issue:
        header: 'Emisión manual y automática de los códigos a los clientes'
        comment:
          'Activela para configurar esta promoción para que los clientes puedan recibir los códigos para acceder a ella'
        enable: label:
          'Activar la emisión de los códigos con notificación por SMS'
        issue_sms_text:
          label: 'Texto de SMS'
          placeholder: 'Texto'
          example:
            label: 'Por ejemplo:'
            text:
              '[name], como disculpa por el retraso en la entrega del pedido, queremos regalarle una pizza, por favor especifique el código [code] en su próximo pedido'
        length:
          label: 'Longitud del código'
          placeholder: 'cantidad de los caracteres'
          caption:
            'Cuantos más caracteres, menor es la probabilidad de que el cliente pueda recogerlos, pero más difícil es ingresarlos.'
        ttl:
          label: 'Vida útil de cada código, días'
          placeholder: 'días'
          caption:
            'Después del número de días especificado, el código se eliminará.<br>0 — nunca eliminar códigos.'
        manual_enable:
          'Permitir la emisión manual de los códigos a los clientes'
      issue_late:
        header: 'Bonos por llegar tarde'
        comment:
          'Puede configurar esta promoción de tal manera que por cada pedido entregado con retraso, se envíe al cliente un SMS con un código único de esta promoción'
        enable: label: 'Activar los bonos por llegar tarde'
        minutes_amount:
          label: 'Considerar como retraso un retraso mayor que, min:'
          placeholder: 'min.'
      codes:
        header: 'Códigos promocionales reutilizables'
        comment: 'Puede establecer un código que activará la promoción.'
        code:
          label: 'Código promocional reutilizable'
          placeholder: 'Código secreto'
          caption:
            'Si establecer un código de promoción para una promoción, los invitados podrán especificar el código al realizar un pedido.Si establece un código de promoción para una promoción, los invitados podrán especificar el código al realizar un pedido.'
      error_text:
        label: 'Texto de error para un invitado'
        placeholder: 'Texto de error para un invitado'
        caption:
          'Si el invitado especifica el código correcto, pero la promoción no cumple con los criterios, se le mostrará el texto especificado.'
      required_all_dishes:
        header: 'Presencia de todos los platos especificados en el pedido'
        comment:
          'Por ejemplo, una bebida gratis al pedir una hamburguesa de pollo, papas fritas y ensalada Cole Slow'
        label: 'Lista de los platos'
      required_any_dish:
        header:
          'Presencia en el pedido uno o más platos de la lista especificada'
        comment:
          'Por ejemplo, una bebida gratis en el pedido de cuatro pizzas con carne, pepperoni o champiñones.'
        label: 'Lista de los platos'
        number: 'Cantidad de la lista de platos'
      required_any_dish_categories:
        label: 'Lista de categorías'
      client_requirements:
        header: 'Requisito al clienteу'
        category:
          label: 'Categorías de los clientes'
          caption:
            'el cliente debe pertenecer a una de las categorías especificadas'
        restrict_category:
          label: 'Prohibir ciertas categorías de los clientes'
          caption:
            'El cliente no debe tener ninguna de las categorías enumeradas.'
        recurrence:
          label: 'Volver del cliente'
          caption:
            'El cliente debe tener un de los tipos de volver especificados'
        order_sum:
          label: 'Precio total del pedido'
          warning: 'Se debe especificar el importe del pedido'
        count_order_sum_with_delivery:
          label: 'Incluir costo de entrega'
        repeatable_bonus:
          label: 'Puede funcionar varias veces en un solo pedido'
          caption:
            'Por ejemplo, <em>«por cada hamburguesa en el pedido dar una bebida gratis»</em>'
        for_new_client:
          label: 'Promoción para un nuevo cliente'
          caption:
            'la promoción funcionará para un cliente que todavía no ha tenido un solo pedido'
        nth_order:
          label: 'Número del pedido'
          caption:
            'le permite establecer un descuento para cada pedido del cliente especificado en la factura; los pedidos se mantienen durante el período de promoción'
      bonuses:
        header: 'Bonos'
        comment:
          'Determinan el resultado de aplicación de la promoción en el pedido'
        bonus_dishes: label: 'Añadir los platos especificados al pedido.'
        bonus_price:
          label: 'El precio de los platos de bonificación'
          caption: 'Si quiere regalar platos a un precio especial, y no gratis'
        bonus_free_dishes: label: 'Ofrecer a elegir uno de los platos indicados'
        discount_percent: label: 'Porcentaje de descuento en el pedido'
        discount_fixed: label: 'Descuento fijo por el pedido'
        discount_dishes_percent:
          label:
            'Porcentaje de descuento en platos especificados en las condiciones'
          caption:
            'Le permite establecer un descuento solo para platos específicos, y no para todo el pedido.'
          single_dish: 'para un solo plato de la lista'
          cheapest:
            caption:
              'Por defecto, el descuento irá al plato con el precio más alto. Pero se puede cambiar.'
            enable: 'dar un descuento en el plato más barato'
        assign_tag: label: 'Asignar una categoría a un usuario'
        reset_tag: label:
          'Reiniciar las categorías especificadas del cliente, si las hay'
        issue_code: label: 'Crear y enviar un código de una promoción'
      buttons:
        save: 'Guardar'
        delete: 'Eliminar'
        cancel: 'Cancelar'
    add_promo: 'Añadir una promoción'
    headers:
      index: 'Lista de las promociónes'
      active: 'Promociones activas'
      archived: 'Archivo de las promociónes'
      view_variant:
        cards: 'Tarjetas'
        table: 'Tabla'
        label: 'Opción de visualización'

    during_last_days:
      one: 'Tenía al menos 1 pedido en el último {{count}} día'
      few: 'Tenía al menos 1 pedido en los últimos {{count}} días'
      many: 'Tenía al menos 1 pedido en los últimos {{count}} días'
      other: 'Tenía al menos 1 pedido en los últimos {{count}} días'
  promo_card:
    buttons: edit: 'editar'
    condition:
      dish_discount: 'Descuento en los platos promocionales'
      next_order_in_days: 'Bono por el último pedido:'
      next_order_min_sum: ' por una cantidad no menos que '
      actual_from: 'Términos de la promoción:'
      restaurants_selected: 'Restaurantes:'
      restaurants_all: 'Todos los restaurantes'
      promo_code: 'código promocional:'
      it_free: 'como un regalo'
      order_discount: 'Descuento por un pedido'
      actual_till: 'Promoción ha terminado:'
      copy: 'Copiar link'
      copied: 'Link copiado'
  banners_index:
    header: 'Mostrar banners y app'
    create_button: 'Añadir'
    zero_data:
      header: 'Aún no tienes banners'
      caption: 'Puede utilizar banners para comunicar alguna información a los huéspedes en el sitio web o la aplicación móvil'
  banners:
    disabled_text: 'Lo sentimos, no puede utilizar la función <br>banners'
    back_button: 'Atrás'
    title: 'Editar banner'
    main:
      name:
        label: 'título'
        placeholder: 'Título del banner (para uso interno)'
      view_order:
        label: 'Orden de visualización: '
        placeholder: 'Orden numérico (1, 2, 3...)'
        zero: 'no fijado'
      url_web: "Enlace a la tienda"
      url_mobile: 'Enlace a la aplicación'
      platform:
        label: 'Dónde mostrar el banner: '
        placeholder: 'Elige plataforma'
        web: 'En el escaparate'
        mobile_web: 'En el escaparate (versión móvil)'
        mobile: 'En la aplicación'
        zero: 'no fijado'
      photo:
        label: 'Imagen'
        storyLabel: 'Vista previa de la historia'
      restaurants:
        label: 'Restricción a los restaurantes'
      is_archived:
        label: 'Ocultar banner'
      terms:
        label: 'Fecha de caducidad'
        to: 'hasta'
      story_frames:
        label: 'Marcos de Historia'
        create_frame: 'Añadir'
      has_clickable_popup: 'Popup clickeable'
      has_popup_on_start: 'Popup al iniciar'
      popup_title: 'Título del popup'
      popup_content: 'Texto del popup'
      popup_with_image: 'Ventana emergente con imagen'
      popup_is_blocking: 'Bloqueo de popup'
      cancel_button: 'Texto para el botón de cancelar'
      confirm_button: 'Texto para el botón de confirmar'
      story_title: 'Título de la historia'
      type:
        title: 'Tipo de contenido'
        link: 'Enlace'
        popup: 'Ventana emergente'
        story: 'Historia'
  adverts_index:
    header: 'Anuncios y correo'
    create_button: 'Añadir'
    is_private: 'oculto'
    zero_data:
      header: 'Aún no tiene anuncios'
      caption:
        'Con la ayuda de los anuncios, puede brindarles a los huéspedes cierta información: en el sitio, mediante un mensaje push o de alguna otra manera.'
  adverts:
    tabs:
      table: 'Tabla'
      cards: 'Tarjetas'
    table:
      content:
        name: 'Nombre'
        recurrence: 'Restricción de Recurrencia'
        client_tags: 'Categorías de Clientes'
        restaurants: 'Restaurantes'
        channels: 'Tipos de Canales'
        created_at: 'Fecha de Creación'
    disabled_text:
      'Desafortunadamente, Usted no tiene acceso a la <br> funcionalidad de los anuncios'
    back_button: 'Volver'
    title: 'Edición de un anuncio'
    menu:
      main: 'Datos común'
      preview: 'Vista previa'
      delivery: 'Envío'
      stats: 'Estadísticas'
    main:
      name:
        label: 'Título'
        placeholder: 'Título del anúncio'
      text:
        label: 'Texto'
        placeholder: 'Texto detallado'
      action:
        label: 'Acción de enlace'
        placeholder: 'Enlace desde el botón'
      photo: label: 'Imagen'
      is_private:
        label: 'Acción no pública'
        on_comment:
          'Ahora este anuncio será visible solo a través de un enlace directo, a aquellos a quienes se envió el correo.'
        off_comment:
          'Ahora este anuncio se mostrará a todos cuando ingresen al sitio o aplicación'
      is_archived: label: 'Ocultar un anuncio'
      terms:
        label: 'Validez'
        to: 'hasta'
    preview: link: 'Enlace al anuncio:'
    delivery:
      intro:
        'Para iniciar el envío, seleccione los clientes a los que se debe enviar este anuncio.<br>El envío se puede realizar de inmediato a través de SMS o primero intente a través de una notificación push automática , y solo luego a través de sms.'
      restaurants:
        label: 'Limitación de los restaurantes'
        placeholder: 'No limitar de los restaurantes'
      recurrence:
        label: 'Limitación del volver'
        placeholder: 'Todos'
      were_orders:
        label: 'Había al menos un pedido en el período'
        from: 'desde'
        to: 'hasta'
      were_no_orders:
        label: 'No había pedidos durante el período.'
        not_yet: 'Todavía este criterio no funciona'
        from: 'desde'
        to: 'hasta'
      send_push:
        label: 'Push-notificaciones'
        caption: 'Push-notificacion en los aplicaciones de iOS и Android'
      send_sms:
        label: 'SMS'
        caption: ''
      send_whatsapp:
        label: 'WhatsApp'
        caption: 'Mensaje en WhatsApp'
      text_sms:
        label: 'Texto de SMS'
        placeholder: 'Texto de SMS'
        caption:
          'Para colocar un enlace en el texto, especifíquelo en un campo separado en este formulario y use <code>{link}</code>
          en la plantilla misma.Luego, en el momento del envío, en lugar de éste, se generará un
          enlace único para cada destinatario. Esto nos ayudará a calcular la tasa de conversión de correo electrónico.
          <br>
          Para insertar el nombre de un cliente en un mensaje, utilice la construcción [nombre].'
      push_text:
        label: 'Texto de notificación push'
        placeholder: 'Texto de notificación push'
        caption:
          'No necesita usar enlaces en el texto, pero puede usar emoji 😉'
        error_text: 'La longitud del texto de la notificación Push no debe exceder los 260 caracteres'
      push_title:
        label: 'Título de la notificación push'
        placeholder: 'Título de la notificación push'
        caption: 'Dejar en blanco para utilizar el nombre de la aplicación como título.<br>Recomendamos establecer un máximo de 65 caracteres'
      link:
        label: 'Enlace'
        placeholder: 'Texto de notificación push'
        caption:
          'Si desea que el cliente vea el anuncio al ingresar al sitio, añada el siguiente código al final:'
        notice:
          'Se acortará el enlace para reducir el número de sms y contabilizar las estadísticas de transiciónes'
      promo:
        label: 'Promoción, para cálculo de conversión'
        no_promos:
          'Aún no tienes ninguna promoción. Añade una promoción con un código promocional e ingrésalo aquí, te ayudará a calcular la conversión'
        caption:
          'Todos los pedidos realizados con la promoción seleccionada se contarán como dirigidos en las estadísticas de envío de este anuncio.'
      execution:
        status_label: 'Estado:'
        counting:
          'Estamos buscando clientes de acuerdo con los criterios especificados....'
        found: 'Encontrado de acuerdo con los criterios especificados: '
        execute_button: 'Iniciar el envío'
        scheduled_at:
          label: 'Programar un anuncio'
        cancel:
          cancel_button: 'Cancelar anuncio'
    stats:
      header: 'Estadísticas del envío realizado'
      loading: 'Estamos cargando estadísticas...'
      transport: 'Canal de la entrega:'
      sent: 'Enviado:'
      received: 'Recibido:'
      shown: 'Entregado (SMS):'
      opened: 'Abierto:'
      orders_made: 'Pedidos realizados:'
      average_total: 'Cheque promedio:'
      sum_total: 'Ingresos totales:'
      income_per_sent: 'Ingresos por un anuncio:'
      empty_stat: 'Todavía no hay estadísticas de envío para este anuncio'
      empty_promo:
        header:
          'El anuncio no especifica la promoción de destino: el cálculo de la conversión será inexacto'
        comment:
          '<p>La promoción de destino ayuda al sistema a distinguir los pedidos que los clientes realizaron con ayuda de este anuncio.</p><p>Todos los pedidos en los que se aplicó la promoción especificada se tendrán en cuenta en la conversión</p>'
  loyalties_index:
    header: 'Programas de Fidelización'
    create_button: 'Agregar'
    zero_data:
      header: 'Actualmente no tiene programas de fidelización'
      caption: 'Los programas de fidelización le permiten atraer y retener clientes con recompensas como descuentos o bonificaciones.'
  loyalties:
    new: 'Programa de Fidelización'
    disabled_text: 'Lamentablemente, la funcionalidad de programas de fidelización no está disponible para usted.'
    back_button: 'Atrás'
    title: 'Editar Programa de Fidelización'
    main:
      name:
        label: 'Nombre'
        placeholder: 'Nombre'
      kind:
        label: 'Tipo de Programa de Fidelización: '
        zero: 'No Especificado'
  bonus_categories_index:
    header: 'Categorías de bonificación'
    create_button: 'Agregar'
    zero_data:
      header: 'Aún no tienes ninguna categoría de bonificación'
  bonus_category:
    new: 'Categoría de bonificación'
    disabled_text: 'Lamentablemente, la funcionalidad de las <br>categorías de bonificación no está disponible para usted'
    back_button: 'Atrás'
    title: 'Editar una categoría de bonificación'
    main:
      name:
        label: 'Nombre'
        placeholder: 'Nombre'
      is_working:
        label: 'Categoría activa'
      color:
        label: 'Color de categoría'
      sum_period:
        label: 'Qué período considerar al resumir pedidos'
        placeholder: 'en días'
      sum_upper_bound:
        label: 'Límite superior en la cantidad de pedidos para una categoría'
      bonus_percent:
        label: 'Porcentaje de bonificaciones acumuladas por pedido'
      expense_percent:
        label: 'Porcentaje de deducción de bonos'
      external_id:
        label: 'ID externa'
  client_tags_index:
    header: 'Etiquetas'
    create_button: 'Agregar'
    zero_data:
      header: 'Aún no tienes ninguna etiqueta'
  client_tag:
    new: 'Etiqueta'
    disabled_text: 'Lamentablemente, no tienes acceso a la función de edición de etiquetas'
    back_button: 'Atrás'
    title: 'Editar una etiqueta'
    main:
      name:
        label: 'Nombre'
        placeholder: 'Nombre'
      assign_type:
        label: 'При удовлетворении условий'
        autoassign: 'Ставить'
        autounassign: 'Снимать'
      period:
        label: 'Период отслеживания (дней)'
        from: 'с'
        to: 'по'
      num_of_orders: 'Количество заказов за период'
      spended_sum: 'Выручка по клиенту за период'
      order_frequency: 'Частота заказов за период'
      consumed_category:
        label: 'Заказ блюд из определенной категории'
        non_label: 'Отсутствие заказов из определенной категории'
      consumed_dish:
        label: 'Заказ определенного блюда'
        non_label: 'Отсутствие заказов определенного блюда'
      tags_to_unassign:
        label: 'Eliminar Etiquetas'
      applicable_to_all: 'Aplicar a datos anteriores'

  communication_channels:
    incoming: 'Mensaje entrante'
    auth: 'Mostrar código QR'
    header: 'Canales de Comunicación'
    columns:
      kind: 'Tipo de Canal'
      status: 'Estado'
    kinds:
      whatsapp: 'WhatsApp'
      telegram: 'Telegram'
      push: 'Notificaciones Push'
      sms: 'SMS'
      vk: 'VKontakte'
    status:
      active: 'Activo'
      enabled: 'Activo'
      disabled: 'Desactivado'
      error: 'Error'
    edit:
      priority: 'Prioridad'
      enabled:
        true: 'El canal está activo'
        false: 'El canal está desactivado'
    chats:
      can_send: 'Escribe un mensaje'
      disabled: 'No hay canales disponibles'

  courier:
    new: 'Nuevo mensajero'
    confirms:
      delete: '¿Eliminar mensajero?'
    alerts:
      success:
        title: 'Guardado'
        message: 'Courier guardado exitosamente.'
      delete:
        title: '¡Eliminado!'
        message: 'Courier eliminado.'
      error:
        title: '¡Error!'
    add:
      courier_list: 'Lista de los mensajeros'
      add_button: 'Añadir'
    availability_everywhere: 'Mensajero disponible en todos los restaurantes'
    edit:
      buttons:
        back: 'Volver'
        assign: 'Asignar'
        cancel_assigment: 'Cancelar asignación'
        cancel_order_in: 'Cancelar pedido en'
        create_an_app_in: 'Crear una aplicación en'
      labels:
        avatar: 'Foto'
        name: 'Nombre'
        phone: 'Teléfono'
        login: 'Email'
        password: 'Contraseña'
        repeat_password: 'Confirmación de contraseña'
        courier_status: 'Bloqueado/Despedido'
        select_restaurant: 'Limitación de los restaurantes'
        courier_comment: 'Comentario'
      placeholders:
        name: 'Título'
        phone: 'Ingrese el número de télefono'
        email: 'Ingrese email'
        password: 'Ingrese contraseña'
        repeat_password: 'Confirme la contraseña'
        courier_status: 'Bloqueado/Despedido'
        select_restaurant: 'Limitación de los restaurantes'
        courier_comment: 'Comentario'
      toggle:
        text: 'Bloquear el acceso a Smartomato'
        caption: 'Esto guardará la cuenta pero prohibirá el acceso a Smartomato'
      caption:
        download_courier_app:
          text:
            'Se requiere login y contraseña para ingresar a la aplicación de mensajería. Descargue la aplicación de mensajería'
          ios: ' para iOS '
          android: ' para Android '
          and: 'y'
      is_edit: 'Edición de un mensajero'
      is_new: 'Añadiendo a un mensajero nuevo'
      form_edit_title: 'Complete el siguiente formulario y haga clic en guardar'
      courier_availability_about:
        'Para que el operador vea solo los mensajeros asociados con el restaurante especificado, puede restringir el trabajo del mensajero a algunos establecimientos.'
      transport_type:
        label: 'Tipo de transporte del mensajero'
        about: 'El método de transporte que utiliza el mensajero para las entregas'
        types:
          public_transport: 'En transporte público'
          walk: 'A pie'
          car: 'En coche'

    buttons:
      save: 'Guardar'
      cancel: 'Cancelar'
      delete: 'Eliminar'
  delivery_zone:
    labels:
      # TODO translate from english
      dine_in_name: 'Dine-in settings name'
      color: 'Color de relleno para la zona'
      takeaway_name: 'Título del punto de la recogida'
      minimal_order_price: 'Pedido mínimo ({{unit}})'
      free_delivery_price: 'Encarga gratuita desde ({{unit}})'
      cooking_time: 'Tiempo de cocicíon. (min.)'
      cooking_time_auto: 'Cálculo automático del tiempo de cocción'
      delivery_zone_priority: 'Prioridad de zona'
      courier_order_fee: 'Tarifa de mensajería para la entrega en esta zona:'
      delivery_time_expand_minutes:
        'Ampliar el horario normal de trabajo en (min.)'
      delivery_zone_name: 'Título de la zona'
      delivery_price: 'Precio de la entrga ({{unit}})'
      delivery_time: 'Tiempo total de entrega (min.)'
      transportation_time: 'Tiempo de transporte (min.)'
      outsource_provider: 'Subcontratación de entrega:'
      outsource_subsidy: 'Subvencionar la entrega de:'
      outsource_reject_from_price: 'Prohibición de la entrega a precio de:'
      outsource_free_delivery_price: 'Entrega gratuita desde:'
      service_charge: 'Gastos de servicio (%):'
      fixed_service_charge: 'Cargo por servicio fijo'
      delivery_zone_edit:
        'Es necesario determinar los límites de la zona de la entrega en el mapa:'
      special_condition_comment: 'Comment on special delivery condition'
    placeholders: no_outsource_provider: 'No'
    segments:
      settings: 'Ajustes'
      advanced: 'Además'
      timetable: 'Horario'
    buttons:
      delete: 'Eliminar'
      save: 'Guardar'
      area_edit: 'Editar área'
      area_define: 'Definir los límites de la zona de la entrega'
    validation:
      no_time_intervals:
        'Especifique los intervalos de tiempo de la entrega para el correcto funcionamiento de las herramientas logísticas'
      time_not_valid: 'El tiempo total de entrega debe ser mayor que la suma del tiempo de preparación y el tiempo de transporte'
    popover:
      help_timetable_text:
        '<p>El horario del trabajo le permite establecer el tiempo durante el cual el sistema permitirá la realización de pedidos.</p> <p>A la hora especificada, los mensajeros entregarán el último pedido y completarán el trabajo.</p><p>La cocina se liberará antes según el horario de la entrega especificado en la configuración de la zona.</p><br> <p>⚠️&nbsp;No se establece el horario del trabajo del restaurante, sino la hora en que se puede entregar el pedido.</p> <p>Por ejemplo, si el restaurante está abierto hasta las 22:00 y la entrega dura 1 hora, debe especificar el final de la entrega a las 23:00. De hecho, en las limitaciones, establece la hora de recepción del pedido.</p><p>Del mismo modo, si el restaurante abre a las 10:00 y tambíen se necesita una hora para el camino, al comienzo de la entrega debe especificar las 11:00</p>'
      help_delivery_process:
        '<p>En la ideología de Smartomato, el proceso de cumplimiento de un pedido recibido de un cliente consiste de varias etapas:</p> <ol><li>Confirmación y aprobación del pedido</li> <li>Envío del pedido a la cocina</li> <li>Preparación y completación un pedido</li> <li>Recogida del pedido por mensajería</li> <li>Transporte del pedido</li> <li>Pasar el pedido al cliente<</li></ol> <p>Para que nuestro sistema pueda calcular todas las etapas intermedias de la entrega y realizar un seguimiento de las desviaciones, configure el tiempo de la preparación, el transporte y el tiempo total de la entrega. </p><p>El tiempo total de la entrega no debe ser menos que la suma de los tiempos de la preparación y el transporte, pero puede superarlo si el proceso de aprobación u otros procedimientos organizativos previos al inicio de la preparación son beneficiosos.</p></div>'
      help_priority_text:
        '<p>Puede definir varias condiciones de la entrega que coinciden parcial o totalmente en la zona de la entrega.</p> <p>Estas zonas se pueden vincular tanto a un restaurante como a los diferentes.</p> <p>La selección de una zona adecuada se llevará a cabo de acuerdo con el siguiente principio.</p> <ol> <li>Primero, Smartomato determinará las zonas que incluyen la dirección del cliente</li> <li>Luego, las zonas que coincidan con el horario del trabajo serán elegidas</li> <li>Después de eso, se seleccionarán las zonas que coincidan con el tamaño mínimo del pedido<</li> </ol> <p>Si todavía caben varias zonas, Smartomato buscará la más adecuada:</p> <ol> <li>Se seleccionará primero la zona con mayor prioridad (mayor número = mayor prioridad)</li> <li>Si hay varias zonas con la misma prioridad, entonces se buscará la zona con el precio de entrega más bajo / pedido mínimo más bajo / tiempo de entrega más corto</li> <li>Si hay varias, entonces funcionará la distribución dinámica, teniendo en cuenta la carga actual:</li> </ol> <p>Con la distribución dinámica, se seleccionará una zona que está vinculada a un restaurante con un número menor de los pedidos activos en el momento actual; por lo tanto, si varios restaurantes atienden una dirección, se cargarán igualmente. </p>'
      help_advanced_courier_text:
        '<p>Si definir la tarifa de mensajero para el pedido, en los informes de los pedidos, al agrupar por el mensajero, puede ver la cantidad de los pedidos entregados por el mensajero.</p> <p>⚠️ Tenga en cuenta que todos los pedidos se resumen, incluso todos los cancelados, porque no conocemos la política del pago en su empresa. Para corregir los datos del informe, puede filtrar los pedidos por el estado.</p>'
      help_rush_mode_text:
        '<p>Este modo permitirá a los gerentes de los restaurantes cambiar a una entrega más larga o más costosa cuando tengan demasiados pedidos o alguna otra fuerza mayor.</p> <p>Puede dejar algunos de los campos en blanco, luego, en caso de <alta demanda>, el parámetro correspondiente no cambiará.</p>'
    advanced_settings:
      title: 'Ajustes avanzados'
      advanced_courier: title: 'Pagos a la mensajería'
      rush_settings: title: 'Parámetros para el modo de «alta demanda» '
    timetable_title: 'Hora de recipción de la entrega'
    add_takeaway_or_delivery: 'Añadir una zona o un punto de la recogida'
    is_takeaway: 'Parámetros de la recogida'
    is_delivery: 'Parámetros de la entrega'

    # TODO translate from english
    is_dine_in: 'Dine-in options'

  settings:
    analytics:
      title: 'Etiquetas meta'
      sub_title:
        'Los datos de estas etiquetas son utilizados por los motores de búsqueda y las redes sociales para formar una vista previa de la página'
      meta_title_caption: 'También se utilizará como &lt;title&gt; paginas'
      buttons:
        load_meta_image: 'Cargar Meta Image'
        save: 'Guardar'
        cancel: 'Cancelar'
      placeholders: services: identificator: 'Identificador'
      labels:
        meta_title: 'Meta Title'
        meta_description: 'Meta Description'
        meta_image: 'Meta image'
      services:
        title: 'Servicios de análisis web'
        subtitle:
          'La capacidad de conectar los servicios de análisis web al escaparate de Smartomato'
        feature_text:
          'Smartomato puede registrar la actividad de sus clientes en sistemas de recolección de estadísticas, Registramos no solo la asistencia, sino también los objetivos que le permitirán comprender mejor a sus clientes. Smartomato también está integrado con Google Analytics Enhanced Ecommerce para que pueda evaluar la efectividad de las campañas publicitarias'
        labels:
          ga: 'Google Analytics'
          metrika: 'Yandex.Metrika'
          gtm: 'Google Tag Manager'
          fb_pixel: 'Facebook Pixel'
          vk_pixel: 'VK Pixel'
          mail_pixel: 'Mail.Ru Counter ID'
          data_layer: 'Activar seguimiento de comercio electrónico en DataLayer'
        data_layer_caption:
          'Widget enviará información sobre las actividades de los huéspedes en DataLayer. '
        data_layer_more: 'Para más información sobre DataLayer'
        examples:
          ga: 'Por ejemplo: UA-61543473-1'
          metrika: 'Por ejemplo: 21277873'
          gtm: 'Por ejemplo: GTM-11XX1XX'
          fb_pixel:
            'Por ejemplo: 111111111111 (Código numérico de 12 o más dígitos)'
          vk_pixel: 'Por ejemplo: VK-RTRG-111111-aA1A1'
          mail_pixel: 'Por ejemplo: 123456'
        events:
          open:
            modal:
              order: 'Abrió la ventana de pedidos'
              receipt: 'Abrió un pedido anterior'
              invite: 'Abrió el cuadro de diálogo de invitación'
            configurator: 'Abrió un configurador grande/pequeño'
            quick_configurator: 'y'
          copy_invite: 'Copió el enlace de invitación '
          dish_click: 'Hizo clic en el plato'
          dish_add: 'Añadió un plato al carrito'
          show_delivery_zones: 'Abrió un mapa con las zonas de la entrega'
          address_autodetect:
            'Hizo clic en la detección automática de dirección'
          click_pay: 'Hizo clic en el botón «Pagar»'
          order_paid: 'Pedido pagado'
          click_checkout:
            event: 'Hizo clic en el botón «Hacer un pedido»'
            description:
              no_valid:
                'Pedido creado (estos eventos pueden ser menos si el cliente llenó el formulario incorrectamente)'
              and: 'y'
    business_role:
      zero_data:
        title: 'Aún no se han agregado roles empresariales'
        caption: 'Agrega roles empresariales para una gestión más precisa de accesos y procesos empresariales'
      list_business_role: 'Lista de roles de negocio'
      add_new: 'Añadir'
      delete: '¿Borrar el rol empresarial?'
      cancel: '¿Cancelar los cambios?'
      title:
        is_exist: 'Editar rol de negocio'
        is_new: 'Añadir nuevo rol empresarial'
      subtitle: 'Acceder a partes del sistema Smartomato'
      labels:
        name: 'Nombre del rol'
        permitted_statuses: 'Estados de pedido permitidos'
        privileges: 'Derechos'
        subject: 'Sitio'
        reports_access: 'Acceso a informes'
        can_assign_courier: 'Asignación de mensajeros a pedidos'
      subject:
        table: 'Tablas'
        courier: 'Mensajeros'
        organization: 'Organización'
        draft_dish: 'Platos'
        draft_category: 'Categorías'
        modifier_group: 'Grupos de modificadores'
        modifier: 'Modificadores'
        modifier_scheme: 'Esquema de modificadores en un plato'
        modifier_scheme_item: 'Grupos de un esquema de modificadores'
        delivery_zone: 'Zonas de entrega'
        order: 'Pedidos'
        client: 'Invitados'
        client_tag: 'Invitados tags'
        staff_member: 'Empleados'
        service: 'Planes de tarifas'
        service_subscription: 'Suscripción'
        invoice: 'Facturas'
        invoice_item: 'Detalles de factura'
        billing_info: 'Facturación'
        bank_details: 'Datos bancarios'
        theme: 'Plantillas de temas'
        skin: 'Tema'
        order_item: 'Contenido del pedido'
        buddy: 'Tomadores de pedidos'
        promo: 'Promociones'
        advert: 'Boletín de noticias'
        banner: 'Banners'
        loyalty_program: 'Programas de fidelización'
        business_role: 'Funciones comerciales'
        cooking_line: 'Salas de cocina'
        payment: 'Pagos'
        dish: 'Comidas del sitio web/aplicación (sólo lectura)'
        category: 'Categorías del sitio web/aplicación (sólo lectura)'
        api_user: 'Cuenta personal'
        restaurant: 'Restaurantes'
        brand: 'Marca'
        dish_group: 'Grupo de platos'
        organization_common_file: 'Archivo común de la organización'
        static_page: 'Página estática'
      actions:
        read: 'Ver'
        create: 'Crear'
        update: 'Actualizar'
        destroy: 'Borrar'
        qr: 'Generar código QR'
        publish: 'Publicar'
        stats: 'Estadísticas'
        upload_logo: 'Subir un logo'
        remove_logo: 'Eliminar logotipo'
        upload_favicon: 'Subir favicon'
        upload_meta_image: 'Imágenes SEO'
        import_menu: 'Importar menú (API)'
        support_issue: 'Cartas de soporte'
        check_host: 'Cambiar dominio'
        reorder: 'Ordenar'
        upload_photo: 'Subir una foto'
        upload_avatar: 'Subir avatar'
        update_priorities: 'Actualización de la prioridad de los pedidos'
        delay_bonus: 'Bonificación por retraso'
        status: 'Estado'
        receipt: 'Carta de porte'
        geocode: 'Geocodificación'
        reverse_geocode: 'Geocodificación inversa'
        assign_zone: 'Definir zona'
        confirm: 'Confirmación'
        set_client_sign: 'Firma del cliente'
        place: 'Realizar pedido'
        dispose: 'Dar de baja'
        select_bonus_dish: 'Seleccionar regalo'
        validate: 'Validar'
        logs: 'Registros'
        cancel_outsource: 'Cancelar subcontratación'
        place_outsource: 'Colocar subcontratación'
        bonus_log: 'Historial de bonificaciones'
        commit_bonus_amount: 'Cambio de bonificación'
        switch: 'Cambio de abono'
        detailed: 'Detalles de la cuenta'
        configure: 'Personalizar'
        delete_photo: 'Eliminar foto'
        select: 'Cambiar asunto'
        create_promo_codes: 'Crear códigos promocionales'
        issue_promo_code: 'Emitir códigos promocionales'
        delete_unused_promo_codes: 'Borrar códigos promocionales'
        promo_codes_usage: 'Estadísticas de códigos promocionales'
        clients_count: 'Número de clientes'
        execute: 'Empezar newsletter'
        cancel: 'Cancelar boletín'
        statistics: 'Estadísticas del boletín'
        stat: 'Registro de la cuenta'
        availability: 'Disponibilidad'
        checklist: 'Configuración inicial'
        menu: 'Menú'
        menu_export: 'Exportación del menú'
        categorías: 'Categorías'
        platos: 'Platos'
        retry_pos_export: 'Reintentar exportación pos'
        rate_processed: 'Ritmo procesado'
        unprocessed_counts: 'Conteos sin procesar'
        reset: 'Reiniciar'
        upload_file: 'Subir archivo'
        upload_story_photo: 'Subiendo foto de la historia'
        reorder_story_frames: 'Reordenando los marcos de la historia'
        upload_static_page_photo: 'Subiendo una foto'
        upload_static_page_section_photo: 'Subir foto de la sección'
        reorder_static_page_sections: 'Reordenando secciones'
      placeholders:
        name: 'Nombre del rol'
        permitted_statuses: 'Estados de pedido permitidos'
      staff_members_count: 'Miembros del personal con este rol: {{staffMembersCount}}'
    staff:
      list_staff: 'Список сотрудников'
      add_new: 'Добавить'
      title:
        is_exist: 'Editar a un empleado'
        is_new: 'Añadir a un nuevo empleado'
      subtitile:
        'Acceso de empleados al sistema, establecimientos y otros servicios de Smartomato'
      labels:
        staff_disabled: 'Bloqueado/Despedido'
        staff_role: 'El papel del empleado'
        avatar: 'Avatar'
        name: 'Nombre'
        phone: 'Télefono'
        login: 'Email (login)'
        password: 'Contraseña'
        repeat_password: 'Confirmación'
        notifications: 'Notificaciones'
        connect_sip: 'Conectar SIP'
        sip_login: 'Dirección de SIP'
        sip_password: 'Contraseña a SIP'
        restaurant: 'Restaurantes'
        cooking_line: 'Planta de produción'
      placeholders:
        name: 'Nombre'
        phone: 'Ingrese número de teléfono'
        login: 'Ingrese email'
        password: 'Ingrese contraseña'
        repeat_password: 'Confirmar la contraseña'
      staff_disabled:
        text: 'Bloquear el acceso a Smartomato'
        caption:
          'Esto guardará la cuenta, pero prohibirá el acceso a Smartomato'
      sip_enabled:
        title: 'Configuración de telefonía'
        text: 'Notificar sobre nuevas llamadas'
        caption: '¿Conectar la cuenta SIP al sistema de pedidos?'
      staff_restaurants:
        '¿Qué restaurantes están disponibles para este empleado?'
      staff_cooking_lines: '¿En qué departamentos trabaja el empleado?'
      business_role:
        label: 'Rol empresarial'
        caption: '⚠️ Atención: Al seleccionar un rol empresarial, el empleado recibirá derechos independientes que no guardan relación alguna con los roles estándar'
      staff_role:
        admin:
          title: 'Administrador'
          description: 'Acceso completo a la gestión de la organización'
        manager:
          title: 'Gerente'
          description:
            'Gestión de la disponibilidad de los platos en los restaurantes'
        manager_logist:
          title: 'Gerente de Logistica'
          description:
            'Gestión de los clientes, logística completa y disponibilidad de los platos'
        logist:
          title: 'Logística'
          description: 'Logística de los pedidos'
        regional_admin:
          title: 'Administrador Regional (franquiciado)'
          description:
            'Puede cambiar los restaurantes especificados y precios en ellos. Crear empleados en los restaurantes especificados.'
      notifications: name: 'Títilo'
      notification_url: 'para integrarse con API'
    sip:
      title: 'Ajustes de telifonía'
      explanation:
        '<p>Smartomato puede integrarse con la telefonía IP y simplificar enormemente el trabajo del operador del teléfono.</p> <p>Usted será capaz de averiguar quién está llamando al centro de llamadas antes de levantar el teléfono. El nombre del cliente, su pedido actual, la historia de los pedidos pasados - todo lo que se necesita.</p>'
      disabled:
        before_link: 'No hay opción de integración en su plan tarifario. Puede'
        link: ' cambiar plan tarifario '
        after_link: 'para permitir la integración con la telefonía.'
      enabled:
        before_link:
          'Para configurar la integración, debe seleccionar los empleados queienes recibirán llamadas en la sección'
        link: ' Empleados '
        after_link:
          'Para cada empleado, debe especificar un login SIP y una contraseña en la sección «Telefonía»  en la tarjeta de edición.'
      staff_with_sip:
        title: 'Las llamadas serán aceptadas en el momento'
        go_to_staff: 'ir a gestión de llamadas'
    organization:
      title: 'Configuración de la organización'
      subtitle:
        'Rellene el siguiente formulario y haga clic en guardar por favor'
      caption: id:
        'La ID puede ser necesaria para la integración, en particular para <a href=\'https://developer.smartomato.ru/widget\'>colocar el widget</a> Smartomato en su sitio'
      labels:
        id: 'ID de la organización'
        logo: 'Logo'
        name: 'Nombre de la organización'
        phone: 'Teléfono'
        about: 'Descripción'
        hostname: 'Dirección del sitio'
        advanced_head: 'Configuraciones avanzadas del escaparate de Smartomato'
        advanced_settings:
          head: caption:
            description:
              'Este código se colocará en &lt;HEAD&gt; secciones de la página. Aquí puede especificar HTML, CSS o JavaScript arbitrario (use etiquetas &lt;STYLE&gt y &lt;SCRIPT&gt).'
            warning: 'Atención!'
            ask_support_description_before:
              'El código aparece en la página sin publicar, tenga cuidado. Contacto a'
            ask_support: 'apoyo'
            ask_support_description_after:
              ',si no comprende completamente por qué se necesita todo esto :) Estaremos encantados de ayudar.'
          body: caption: description:
            'Similar, pero en la parte inferior de la página'
        advanced_body: 'Código a colocar al final de la página'
        timezone: 'Zona horaria'
        is_published: 'Publicación'
        vk: 'Vkontakte'
        whatsapp: 'WhatsApp'
      buttons:
        upload_logo: 'Subir un logo'
        change_host: 'Cambiar'
        upload_favicon: 'Subir Favicon'
      is_published:
        text: 'Publicar un restaurante'
        description: '¿Está disponible el restaurante en la dirección indicada?'
      placeholders:
        name: 'Nombre'
        phone: 'Ingrese elnúmero telefónico'
        about: 'Descripción de la organización'
        advanced_head: 'Configuración avanzada del sitio (sección HEAD)'
        advanced_body: 'Configuración avanzada del sitio (sección BODY)'
      lang_settings_helper:
        'Si necesita cambiar la moneda o la configuración de idioma de la organización, escríbanos a soporte y lo ayudaremos.'
    host:
      title: 'Cambio de nombre del dominio'
      subtitile:
        'Selección la dirección donde estará disponible el escaparate de Smartomato'
      explanation:
        text:
          'Para el escaparate Smartomato puede usar la dirección en la zona<b>*.smartomato.ru</b>o enlazar su propio dominio.  Para la dirección de tipo <b>имя_ресторана.smartomato.ru</b> Simplemente seleccione cualquier dirección desocupada y todo funcionará automáticamente!'
        before_link:
          'Al usar tu propia dirección, todo es un poco más complicado, pero te lo contamos.'
        link: 'Escríbanos en apoyo de'
        after_link: ', y trataremos de ayudarle lo antes posible.'
    integrations:
      title: 'Integración en Smartomato'
      feature_text:
        'Smartomato puede interactuar con muchos servicios, escríbenos y te ayudaremos a configurar'
      feature:
        pos:
          title: 'Contabilidad de los restaurantes'
          poster:
            title: 'Poster'
            description:
              'Envío de los pedidos confirmados de Smartomato a la cocina. Importar menús y restaurantes de Poster a Smartomato.'
          r_keeper:
            title: 'R-Keeper'
            description:
              'Envío de los pedidos confirmados de Smartomato a la cocina.'
          iiko:
            title: 'Iiko'
            description:
              'Envío de los pedidos confirmados de Smartomato a la cocina.'
          frontpad:
            title: 'Frontpad'
            description: 'Envío de los pedidos confirmados de Smartomato a la cocina.'
          sbis:
            title: 'СБИС Presto'
            description: 'Envío de pedidos confirmados desde Smartomato a la cocina.'

        aquiring:
          title: 'Adquisidor'
          yandex:
            title: 'Yandex.Pagar'
            description:
              'Aceptar pago online. Tarjetas bancarias Visa, Mastercard, Maestro, Mir, JCB, Diners Club, American Express. Dinero Yandex. QIWI Monedero.'
          cloud_payments:
            title: 'Cloudpayments'
            description:
              'Aceptar pago online. Tarjetas bancarias Visa, Mastercard, Maestro, Mir.'
          sberbank:
            title: 'Sberbank'
            description:
              'Aceptar pago online. Tarjetas bancarias Visa, Mastercard, Maestro, Mir'
          ibox:
            title: 'iBox'
            description:
              'Aceptación de pagos que no sean en efectivo utilizando un teléfono inteligente y un terminal móvil. Tarjetas bancarias Visa, Mastercard, Maestro, Mir'
          pay_keeper:
            title: 'PayKeeper'
            description:
              'Adquisición de bancos: VTB, Sberbank, Promsvyazbank, Otkritie Bank, Moscow Credit Bank, Russian Standard Bank, TransKapitalBank, Gazprombank, URALSIB BANK, Bank St. Petersburg, UBRD, POST BANK, QIWI Bank'
          alfa_bank:
            title: 'Alfa Bank'
            description: 'Aceptar pago online. Tarjetas bancarias Visa, Mastercard, Maestro, Mir'
          tinkoff:
            title: 'Tinkoff'
            description: 'Aceptar pago online. Tarjetas bancarias Visa, Mastercard, Maestro, Mir'
          yandex_check:
            title: 'Yandex.Check'
            description: 'Aceptar pago online. Tarjetas bancarias Visa, Mastercard, Maestro, Mir'
        loyalty:
          title: 'Sistemas de fidelización'
          sber_food:
            title: 'SberComida'
            description:
              'Los restaurantes que usan SberFood rastrean datos sobre el uso de bonos en la interfaz de Smartomato, y los invitados del restaurante acumulan y gastan bonos al ordenar la entrega.'
          premium_bonus:
            title: 'Premium Bonus'
            description:
              'Una sola cuenta de bonificación para invitados: al visitar un restaurante sin conexión y al pedir la entrega. Sincronización bidireccional de datos sobre clientes, acumulación y cancelación de bonos.'
          iiko_card:
            title: 'iikoCard'
            description: 'Un sistema de bonos y depósitos diseñado para gestionar relaciones con clientes habituales, y apoyar esquemas de comidas corporativas.'
          primehill:
            title: 'PrimeHill'
            description: 'Un sistema conveniente para automatizar las comunicaciones de marketing.'
        analytics:
          title: 'Analíticos de punta a punta'
          calltouch:
            title: 'Calltouch'
            description:
              'Transmisión automática de información de los pedidos telefónicos como tratos a Calltouch y asignación de fuentes publicitarias.'
        delivery_outsource:
          title: 'Subcontratación de la entrega'
          yandex_go:
            title: 'Yandex.Entrega'
            description:
              'Creación y transferencia automáticas de una solicitud de la entrega de Smartomato a Yandex. Entrega, sincronización de estados de los pedidos, configuración de subsidios e informes detallados.'
          dostavista:
            title: 'Dostavista'
            description:
              'Automatización completa: cálculo del costo y el tiempo de la entrega, transferencia de una solicitud de la entrega, intercambio síncrono de estados de los pedidos, formación de los informes.'
          broniboy:
            title: 'Broniboy'
            description: 'Creación automática y envío de solicitudes de entrega desde Smartmato a Broniboy, sincronización de estados de pedido, configuración de subsidios e informes detallados.'
        messaging:
          title: 'SMS и otros mensajeros'
          main_sms:
            title: 'MainSMS'
            description:
              'SMS a los clientes con el nombre del remitente seleccionado.'
          smsc:
            title: 'Centro de SMS'
            description:
              'SMS a los clientes con el nombre del remitente seleccionado.'
          megafon:
            title: 'Megafon'
            description:
              'SMS a los clientes con el nombre del remitente seleccionado.'
          infobip:
            title: 'Infobip'
            description:
              'SMS a los clientes con nombre de remitente seleccionado. Envío de mensajes a mensajeros: en desarrollo'
          whatsapp:
            title: 'WhatsApp'
            description: 'Envío de mensajes desde la cuenta oficial de la empresa a los usuarios en el mensajero de WhatsApp.'
          sms_agent:
            title: 'SMS-agent'
            description: 'SMS a los clientes con el nombre del remitente seleccionado.'
          beeline:
            title: 'Beeline'
            description: 'SMS a los clientes con el nombre del remitente seleccionado.'
          mts:
            title: 'MTS Marketer'
            description: 'SMS a los clientes con el nombre del remitente elegido.'
          sms_aero:
            title: 'SMS Aero'
            description: 'SMS a los clientes con el nombre del remitente elegido.'
        aggregators:
          title: 'Agregadores'
          yandex_eda:
            title: 'Yandex.Food'
            description:
              'Subir el menú del restaurante al servicio. Procesamiento de los pedidos recibidos a través de Yandex.Food (importación, notificaciones, cancelación, actualización del estado).'
          delivery_club:
            title: 'Delivery Club'
            description:
              'Subir el menú del restaurante al servicio. Procesamiento de los pedidos recibidos a través de Delivery Club (importación, notificaciones, cancelación, actualización del estado).'
          broniboy:
            title: 'Broniboy'
            description:
              'Subir el menú del restaurante al servicio. Procesamiento de los pedidos recibidos (importación, notificaciones, cancelación, actualización del estado).'
          obed_ru:
            title: 'Obed.ru'
            description:
              'Importación de los pedidos recibidos a través de Обед.ру'
          zakazaka:
            title: 'ZakaZaka'
            description:
              'Subir el menú del restaurante al servicio. Procesamiento de los pedidos recibidos a través de ZakaZaka (importación, notificaciones, cancelación, actualización de estado).'
          chibbis:
            title: 'Chibbis'
            description:
              'Subir el menú del restaurante al servicio. Procesamiento de los pedidos recibidos a través de Chibbis (importación, notificaciones, cancelación, actualización de estado).'
          glovo:
            title: 'Glovo'
            description:
              'Subir el menú del restaurante al servicio. Procesamiento de los pedidos recibidos a través de Glovo (importación, notificaciones, cancelación, actualización de estado).'
          vk:
            title: 'Vk'
            description: 'Subir el menú del restaurante al servicio. Procesamiento de los pedidos recibidos a través de Vk (importación, notificaciones, cancelación, actualización de estado).'
          sbermarket:
            title: 'Sbermarket'
            description: 'Subir el menú del restaurante al servicio. Procesamiento de los pedidos recibidos a través de Sbermarket (importación, notificaciones, cancelación, actualización de estado).'
      buttons: connect: 'Conectar'
    payments:
      title: 'Formas de pago del pedido por parte de los clientes'
      subtitile:
        'Gestionar la disponibilidad de la elección de los métodos de pago al realizar un pedido'
      feature:
        description:
          'Especifique los métodos de pago que el cliente puede elegir al realizar un pedido. Tenga en cuenta que algunos métodos de pago requieren configuraciones adicionales.'
        cash:
          title: 'En efectivo al recibir'
          description:
            'El pago se realiza a su mensajero al recibir el pedido. En este caso, en el formulario del pedido habrá una pregunta sobre la necesidad de que el servicio de mensajería lleve cambio con una cierta cantidad del cliente. Este servicio no requiere ninguna configuración adicional.'
        card_online:
          title: 'Con la tarjeta online'
          caption:
            before_support:
              'Después de formar un pedido, se le pedirá al cliente que ingrese los detalles de la tarjeta para pagar el pedido. Para que este método de pago funcione, se requiere integración con la adquisición por Internet, no es difícil - '
            support: 'escribanos'
            after_support: ' y nosotros haremos lo todo.'
        courier_card:
          title: 'Con la tarjeta al recibir'
          description:
            'Este método de pago es posible si sus mensajeros tienen terminales móviles. En <a href=\'https://play.google.com/store/apps/details?id=ru.smartomato.order_machine\' target=\'_blank\'>La aplicación de la mensajería de Smartomatо</a> hay una integración con <a href=\'http://iboxmpos.com/\' target=\'_blank\'>iboxPro</a>, un servicio que le permite aceptar tarjetas usando su teléfono inteligente.'
    profile:
      title: 'Configuración de perfil'
      subtitle: 'Aquí puede editar su perfil'
      labels:
        photo: 'Avatar'
        name: 'Nombre'
        phone: 'Teléfono'
        login: 'Email (login)'
        password: 'Contraseña'
        password_repeat: 'Confirmación'
      placeholders:
        name: 'Nombre'
        phone: 'Ingrese el número de teléfono'
        login: 'Ingrese email'
        password: 'Ingrese contraseña'
        password_repeat: 'Ingrese contraseña'
    developer_settings:
      title: 'Características adicionales'
      subtitle:
        'Sección de configuración y características para usuarios avanzados'
      feature:
        import_menu:
          title: 'Importación de menú'
          description:
            '<p>Carga por lotes del menú de la organización desde un archivo JSON. Antes de usar, lea la descripción del formato de archivo en la <a href=\'http://developer.smartomato.ru/api\'> documentación para desarrolladores de Smartomato.</a></p> <p>¡Atención! El menú antiguo será reemplazado completamente por el importado, lo que puede provocar la pérdida de estadísticas. </p>'
        export_menu:
          title: 'Exportar Menú'
          description: '<p>Exporta el menú como un archivo JSON</p>'
          action: 'Exportar'
          description_yml: '<p>Exportar el menú como un archivo YML</p>'
          all_menu: 'Todo el menú'

        import_clients:
          title: 'Importación de los clientes'
          description:
            '<p>Carga por lotes de datos sobre los clientes de la organización desde un archivo JSON. Antes de usar, lea la descripción del formato de archivo en<a href=\'http://developer.smartomato.ru/api\'>documentación para desarrolladores de Smartomato</a></p>'
          label: 'Eliminar clientes creados anteriormente'
    interface:
      title: 'Configuración de la interfaz'
      subtitle: 'Se guarda la configuración de un navegador específico'
      feature:
        language:
          label: 'Idioma de la interfaz del gabinete de gestión'
          caption:
            'Esta configuración cambia SOLO la interfaz de usuario en el navegador actual, no se cambiará la configuración de la organización'
        low_perfomance:
          description:
            'Actvela si tiene muchos pedidos, la computadora no puede hacer frente y la interfaz deja de responder'
          disable: 'Modo predeterminado, sin restricciones'
          enable:
            'Ahora la interfaz muestra menos información e intenta actualizarla con menos frecuencia'
        hide_map:
          description: 'No mostrar el mapa en la pestaña del pedido'
          enable: 'El mapa está oculto, también reducirá la carga en el ordenador'
          disable: 'Mapa se mostrará'
        map_mouse_wheel:
          description: 'Controlar la escala del mapa con la rueda del ratón'
          enable: 'La rueda del ratón hará zoom'
          disable: 'La rueda del ratón se desplazará '
        check_interval:
          description:
            'Frecuencia de actualización de los puestos de control en los pedidos'
          enable: 'Intervalo de actualización está enstalado {{interval}} min.'
        notification_duration:
          description: 'Cuánto tiempo para mostrar la notificación de brindis'
          enable: 'Las notificaciones se ocultarán después de {{interval}} segundos.'
        hide_order_notifications:
          description:
            'Ocultar las notificaciones sobre nuevos pedidos y sus cambios del estado'
          enable: 'Las notificaciones están ocultas'
          disable: 'Notificaciones están mostradas'
        hide_pickup_orders_at_now:
          description:
            'Ocultar pedidos de recogida en la lista de pedidos \'ahora\'\''
          enable: 'Los pedidos de recogida están ocultos'
          disable: 'Se muestran todos los pedidos'
        sound_notifications:
          description: 'Reproduce alertas sonoras cuando llega un nuevo pedido'
          enable: '<br>¡Alertas de sonido están activados!'
        sound_notifications_verbose:
          description:
            'Reproducir alertas de sonido en cualquier evento (no recomendado)'
          enable: '<br>🎉🥁🥳🎊!'
        sound_notifications_repeat:
          description:
            'Repetir las alertas sonoras cuando llega un nuevo pedido'
          enable: '<br>Alertas de sonido repetitivas se han activado!'
        repeat_interval:
          description: 'Frecuencia de repetición de alertas de sonido'
          enable: 'Intervalo de repetición{{interval}} sec.'
        integrations_settings:
          description: 'Abrir los ajustes de integración desde el panel de control'
          enable: '<br>Los ajustes de integración ya no están en una ventana aparte.'
        hide_later_orders_on_map:
          description: 'Ocultar pedidos "Más tarde" en el mapa'
          enable: '<br>Solo los pedidos "Ahora" aparecerán en el mapa'
        hide_unauthorized_couriers:
          description: 'Ocultar mensajeros no autorizados en el mapa'
          enable: '<br>Solo los mensajeros que trabajan se mostrarán en el mapa'
        show_button_for_optional_modifiers:
          description: 'Botón separado para modificadores opcionales en la tarjeta de pedido'
          enable: '<br>Los modificadores obligatorios estarán disponibles al hacer clic en el plato, los modificadores opcionales estarán disponibles al hacer clic en el botón al lado del plato'
        show_dish_photo_in_order_card:
          description: 'Mostrar fotos de platos en la tarjeta de pedido'
          enable: '<br>Las fotos de los platos se mostrarán en la tarjeta del pedido'
        show_assigned_courier_in_order_card:
          description: 'Mostrar el mensajero seleccionado en la tarjeta de pedido'
          enable: '<br>El mensajero seleccionado se mostrará en la tarjeta de pedido en las pestañas ahora\\más tarde'

  sm_chosen:
    nothing_found: 'Nada encontrado'
    buttons: add_button: 'Añadir'
    placeholders: search: 'busqueda'
  date_range_report:
    from: 'desde'
    to: 'hasta'
  day_editor:
    to: 'hasta'
    add: 'Añadir'
    time_hint:
      'Para añadir un período, debe ajustar el período anterior, no debe terminar con 23:59'
    not_working: 'No funcionamos'
  sm_delivery_map:
    buttons:
      finish: 'Terminar'
      cancel: 'Cancelar'
  sm_button:
    back: 'Volver'
    save: 'Guardar'
    cancel: 'Cancelar'
    delete: 'Eliminar'
    upload: 'Subir'
    change: 'Cambiar'
  sm_notification_limiter:
    text: 'Además {{noticifationPending}} notificaciones'
    hide_all: 'ocultar las notificaciones'
  tariff:
    price_text: '{{tarrifPrice}} r/mes'
    buttons: select_tariff: 'Eligir'
    full_tariffs:
      'Versión completa de tarifas y su comparación en <a href="https://smartomato.ru/pricing" target="_blank">sitio de Smartomato</a>.}}'
  available:
    available: 'Disponible'
    not_available: 'En la lista de paradas'
    call: 'Consultar disponibilidad por teléfono'
  validation:
    phone: 'El número de teléfono debe contener solo números y +'
    login: 'Email incorrecto'
    required_field: 'Campo requerido'
  errors:
    status: 'El estado no se puede establecer.'
    code:
      403: 'Derechos insuficientes para realizar esta acción.'
